import React, { useEffect, useState, useRef } from 'react'
import { INVITATION_LOOKUP, INVITATION_LOOKUP_GTPASS, INVITATION_GUESTLIST_CHKGUESTID, INVITATION_LOOKUP_GTPASSGTUID } from '../../config/api'
import { a_fs, d_fs, e_fs, IMG_ALT, FS_LH_MAP, FACEBOOK_ICON, INSTAGRAM_ICON, HUMAN_ICON, ALLDEFAULTIMGS, videoadgate, INVITATION_COUPLE_DEFAULT_IMGS_MAP, WEB, TABLET, } from '../../config/constants'
import { ScreenWidth, Loading, Nohori, Loginpasscode, ScreenHeight, Invdate } from '../../components'
import { T1, T2, Opening, RSVP, Igallery } from './components'
import { Textfit } from 'react-textfit';
// import { combineNames } from '../Main/Planning/Invitationmaker/commonfunctions/commonfunctions'
import Timelineobj from '../../components/Timelineobj/Timelineobj'
import axios from 'axios'
// import {
//     twosvg,
//     foursvg,
//     fivesvg,
//     sixsvg,
//     sevensvg,
//     eightsvg,
//     aws_icecream,
//     aws_icecreamcolor,
//     aws_peachflower,
//     aws_pinkflower,
//     aws_sakura,
//     aws_smallflower,

//     aws_masspurpleflower,
//     aws_smallwhite,
//     aws_manyred,
//     aws_smallmasspurple,
//     aws_smallwhites,
//     aws_whiteredyellow,
//     aws_commonpink,
//     aws_branchespink,
//     aws_cloudpink,
//     aws_patternint1,
//     aws_patterngold1,
//     aws_toiletroll,
//     aws_emptyshelf,

//     floral1, floral2, floral3, floral4, floral5, floral6, floral7, floral8, floral9, floral10,
//     floral11, floral12, floral13, floral14, floral15, floral16, floral17, floral18, floral19, floral20,
//     floral21, floral22, floral23, floral24, floral25, floral26, floral27, floral28, floral29, floral30,
//     floral31, floral32, floral33, floral34, floral35, floral36, floral37, floral38, floral39, floral40,
//     floral41, floral42, floral43, floral44, floral45, floral46, floral47, floral48, floral49, floral50,
//     floral51, floral52, floral53, floral54, floral55, floral56, floral57, floral58, floral59, floral60,
//     floral61, floral62, floral63, floral64, floral65, floral66, floral67, floral68, floral69, floral70,
//     floral71, floral72, floral73, floral74, floral75, floral76, floral77, floral78, floral79, floral80,
//     floral81, floral82, floral83, floral84, floral85, floral86, floral87, floral88, floral89, floral90,
//     floral91, floral92, floral93, floral94, floral95, floral96, floral97, floral98, floral99, floral100,

// } from './../../assets/invitationcard'
import Jfmap from '../../components/Jfmap/Jfmap'
import { title_0, title_1, title_2 } from '../Main/Planning/Invitationmaker/constants'
import Circularclosebtn from '../../basic_components/Button/Circularclosebtn/Circularclosebtn'
import { THINWECHAT_ICON, THINWHATSAPP_ICON, THININSTAGRAM_ICON, THINFACEBOOK_ICON, THINTELEGRAM_ICON, GALLERY_ICON, ITINERARY_ICON, RSVP_ICON, SEATINGS_ICON, RSVPTELEPHONE_ICON, GUESTBOOK_ICON, SMALLERMORE_ICON, SOCIALMEDIA_ICON, PROMOTE_ICON, CONTACT_ICON, PLAY_ICON, PAUSE_ICON, REGISTRY_ICON, EXPAND_ICON, LOCK_ICON } from '../../config/svgicons'
import { getS3fullpath_withbucketname, iconwrapper } from '../../config/commonfunctions'
import { allimages } from '../../assets/invitationcard/index1'
// import Mobiletemplate from './components/Mobiletemplate/Mobiletemplate'
import Runsvg from '../../components/Runsvg/Runsvg'
// import ScrollDownReason from '../Presentation/Presentationinvitationlookup/ScrollDownReason/ScrollDownReason'
import ScrollDownImageChangeAndReason from '../Presentation/Presentationinvitationlookup/ScrollDownImageChangeAndReason/ScrollDownImageChangeAndReason'
import { S3CLOUD_CLOUDFRONT, S3CLOUD_CLOUDFRONT_ASSET } from '../../config/s3directories'
import './invitationlookup.css'

const INFINITELOOP_MODE = 2
const EMPTY_SVG = 0
const MOBILE_ASPECT_RATIO = 4 / 3

const debug = true

// const BGS = [

//     // 0 - 6
//     '', twosvg, foursvg, fivesvg, sixsvg, sevensvg, eightsvg,

//     // 7 - 25
//     aws_icecream, aws_icecreamcolor, aws_peachflower, aws_pinkflower, aws_sakura,
//     aws_smallflower, aws_masspurpleflower, aws_smallwhite, aws_manyred, aws_smallmasspurple,
//     aws_smallwhites, aws_whiteredyellow, aws_commonpink, aws_branchespink,
//     aws_cloudpink, aws_patternint1, aws_patterngold1, aws_toiletroll, aws_emptyshelf,

//     // 27 - 38 | WT : 1000 . HT : 1000
//     floral1, floral2, floral3, floral4, floral5, floral6, floral7, floral8, floral9, floral10,
//     floral11, floral12, floral13, floral14, floral15, floral16, floral17, floral18, floral19, floral20,
//     floral21, floral22, floral23, floral24, floral25, floral26, floral27, floral28, floral29, floral30,
//     floral31, floral32, floral33, floral34, floral35, floral36, floral37, floral38, floral39, floral40,
//     floral41, floral42, floral43, floral44, floral45, floral46, floral47, floral48, floral49, floral50,
//     floral51, floral52, floral53, floral54, floral55, floral56, floral57, floral58, floral59, floral60,
//     floral61, floral62, floral63, floral64, floral65, floral66, floral67, floral68, floral69, floral70,
//     floral71, floral72, floral73, floral74, floral75, floral76, floral77, floral78, floral79, floral80,
//     floral81, floral82, floral83, floral84, floral85, floral86, floral87, floral88, floral89, floral90,
//     floral91, floral92, floral93, floral94, floral95, floral96, floral97, floral98, floral99, floral100,

// ]

// const NO_TEMPLATE = -1
// const SIDEBYSIDE_TEMPLATE = 0
// const LONG_TEMPLATE = 1

function Checkdevice() {
    const W = ScreenWidth()
    if (W > WEB) {
        return 'WEB'
    }
    else if (W > 550) {
        return 'TABLET'
    }
    else {
        return 'MOBILE'
    }
}

function getImageDetails(img) {
    const local_width = img.naturalWidth;
    const local_height = img.naturalHeight;
    const aspectRatio = local_width / local_height;
    let orientation;
    if (local_width > local_height) {
        orientation = 'landscape';
    } else if (local_height > local_width) {
        orientation = 'portrait';
    } else {
        orientation = 'square';
    }
    return { orientation, aspectRatio }
}

const getUniqueThumbnails = (imageMap) => {
    const thumbnailsSet = new Set();
    Object.values(imageMap).forEach(images => {
        images.forEach(image => {
            if (image.thumbnail) {
                thumbnailsSet.add(image.thumbnail);
            }
        });
    });
    return Array.from(thumbnailsSet);
};

const getUniqueImgs = (imageMap) => {
    const imgSet = new Set();
    Object.values(imageMap).forEach(images => {
        images.forEach(image => {
            if (image.img) {
                imgSet.add(image.img);
            }
        });
    });
    return Array.from(imgSet);
}



// T1

const T1Single_WEB = ({ heroimgs, wt, br, onload, mainimg_ref, transition_css_mainimg, portrait_or_landscape, device }) => { // DONE
    return <img
        ref={mainimg_ref}
        id="ilookup_imgid"
        className={"ilookup_single_img_" + portrait_or_landscape}
        onLoad={onload}
        src={heroimgs[0]}
        style={{
            width: wt,
            height: device === 'MOBILE' && portrait_or_landscape === 'landscape' ? wt : 'auto',
            borderRadius: br,
            ...transition_css_mainimg
        }}
    />
};

const T1Single_MOBILE = ({ heroimgs, wt, br, onload, mainimg_ref, transition_css_mainimg, portrait_or_landscape }) => { // DONE
    return <img
        ref={mainimg_ref}
        id="ilookup_imgid"
        className={"ilookup_single_img_" + portrait_or_landscape}
        onLoad={onload}
        src={heroimgs[0]}
        style={{
            width: wt,
            height: 'auto',
            borderRadius: br,
            ...transition_css_mainimg
        }}
    />
};

const T1Marquee_WEB = (props) => { // DONE
    // ONLY PORTAIT IMAGE DISPLAYING, USER CAN ONLY UPLOAD PORTRAIT IMAGE
    const { br, onload, mainimg_ref, portrait_or_landscape, device, wt } = props

    const [adjustedspeed, setAdjustedspeed] = useState(-1)
    const [totalcontentwidth, setTotalcontentwidth] = useState(-1)
    const [heroimgs, setHeroimgs] = useState([])
    const styleElRef = useRef(null);
    const marqueeRef = useRef(null);

    useEffect(() => {
        if (!props.heroimgs || props.heroimgs.length === 0) return;
        setTotalcontentwidth(wt * props.heroimgs.length)
        setAdjustedspeed(((wt * props.heroimgs.length) / 500) * 2);
        setHeroimgs(props.heroimgs);

    }, [props.heroimgs, wt]);

    useEffect(() => {
        if (!totalcontentwidth || totalcontentwidth <= 0) return;

        const styleId = 't1-marquee-keyframes-style';

        // Check if a style with this ID already exists
        let styleEl = document.getElementById(styleId);

        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = styleId;
            document.head.appendChild(styleEl);
        }

        styleEl.innerHTML = `
          @keyframes marquee {
            from { transform: translateX(0); }
            to { transform: translateX(-${totalcontentwidth}px); }
          }
        `;

        styleElRef.current = styleEl;

        // Cleanup only if this component added it
        return () => {
            const existing = document.getElementById(styleId);
            if (existing) {
                document.head.removeChild(existing);
            }
            styleElRef.current = null;
        };
    }, [totalcontentwidth]);

    return (
        <div
            className='ilookup_marquee_root'
            ref={mainimg_ref}
            style={{
                display: 'block',
                justifySelf: 'center',
                overflow: "hidden",
                whiteSpace: "nowrap",
                borderRadius: br,
                aspectRatio: 4 / 5,
                height: 'auto',

            }}>
            <div
                ref={marqueeRef}
                style={{
                    minWidth: wt,
                    display: "flex",
                    animation: `${adjustedspeed}s linear infinite marquee`,  // Use adjustedSpeed here
                    willChange: "transform", // added for smoother animation
                }}
            >
                {[...heroimgs, ...heroimgs].map((img, index) => {
                    return <img
                        // className={'ilookup_marquee_img_' + portrait_or_landscape + '_' + device}
                        onLoad={onload}
                        key={index + img}
                        src={img}
                        style={{
                            aspectRatio: 4 / 5,
                            display: 'flex',
                            objectFit: 'cover',
                            height: '100%',
                            maxWidth: wt,
                            minWidth: wt,
                        }}
                    />
                }

                )}
            </div>
        </div>
    );
};

const T1Slideshow_WEB = ({ // DONE
    heroimgs,
    wt,
    ht,
    br,
    onload,
    mainimg_ref,
}) => {
    // landscape image only
    const duration = heroimgs.length * 4; // 4s per image
    return (
        <div
            ref={mainimg_ref}
            style={{
                width: wt,
                height: ht,
                borderRadius: br,
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            {heroimgs.map((img, i) => (
                <img
                    key={i}
                    src={img}
                    onLoad={onload}
                    className="slideshow-img"
                    style={{
                        height: '100%',
                        animation: `fadecycle ${duration}s infinite`,
                        animationDelay: `${i * 4}s`, // shift start for each image
                    }}
                />
            ))}

            <style>{`
          .slideshow-img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            top: 0;
            left: 0;
            opacity: 0;
          }
  
          @keyframes fadecycle {
            0% { opacity: 1; }
            33.3333% { opacity: 1; }
            50% { opacity: 0; }
            83.3333% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}</style>
        </div>
    );
};

const T1Slideshow_MOBILE = ({ // DONE
    heroimgs,
    wt,
    onload,
    mainimg_ref,
}) => {
    const duration = heroimgs.length * 4; // 4s per image
    return (
        <div
            ref={mainimg_ref}
            style={{
                overflow: "hidden",
                position: "relative",
                width: wt,
                height: wt,
            }}
        >
            {heroimgs.map((img, i) => (
                <img
                    key={i}
                    src={img}
                    onLoad={onload}
                    className="slideshow-img"
                    style={{
                        animation: `fadecycle ${duration}s infinite`,
                        animationDelay: `${i * 4}s`, // shift start for each image
                        width: wt,
                        height: wt,
                    }}
                />
            ))}

            <style>{`
          .slideshow-img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            top: 0;
            left: 0;
            opacity: 0;
          }
  
          @keyframes fadecycle {
            0% { opacity: 1; }
            33.3333% { opacity: 1; }
            50% { opacity: 0; }
            83.3333% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}</style>
        </div>
    );
};

const T1_AND_T2_Marquee_MOBILE = ({ heroimgs = [], wt, onload, mainimg_ref }) => {  // DONE

    const marqueeRef = useRef(null);
    const animationRef = useRef(null);

    const [adjustedspeed, setAdjustedspeed] = useState(0); // pixels per second
    const [contentWidth, setContentWidth] = useState(0);

    useEffect(() => {
        if (!heroimgs.length || !wt) return;
        const totalWidth = wt * heroimgs.length;
        setContentWidth(totalWidth);
        setAdjustedspeed((totalWidth / 500) * 100); // your original logic — can tweak multiplier
    }, [heroimgs, wt]);

    useEffect(() => {
        if (!contentWidth || !adjustedspeed || !marqueeRef.current) return;

        const marquee = marqueeRef.current;
        let offset = 0;
        let lastTimestamp = performance.now();

        const animate = (timestamp) => {
            const deltaTime = (timestamp - lastTimestamp) / 1000; // in seconds
            lastTimestamp = timestamp;

            offset -= adjustedspeed * deltaTime; // pixels = speed (px/sec) * time (sec)

            if (Math.abs(offset) >= contentWidth) {
                offset = 0;
            }

            marquee.style.transform = `translateX(${offset}px)`;
            animationRef.current = requestAnimationFrame(animate);
        };

        animationRef.current = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationRef.current);
    }, [adjustedspeed, contentWidth]);

    return (
        <div
            ref={mainimg_ref}
            style={{
                overflow: 'hidden',
                width: wt,
                height: wt,
                whiteSpace: 'nowrap',
                position: 'relative',
            }}
        >
            <div
                ref={marqueeRef}
                style={{
                    display: 'flex',
                    willChange: 'transform',
                }}
            >
                {[...heroimgs, ...heroimgs].map((img, idx) => (
                    <img
                        key={idx}
                        src={img}
                        onLoad={onload}
                        style={{
                            width: wt,
                            height: wt,
                            objectFit: 'cover',
                            flexShrink: 0,
                        }}
                    />
                ))}
            </div>
        </div>
    );
    // const { wt, onload, mainimg_ref } = props
    // const [adjustedspeed, setAdjustedspeed] = useState(-1)
    // const [totalcontentwidth, setTotalcontentwidth] = useState(-1)
    // const [heroimgs, setHeroimgs] = useState([])
    // const styleElRef = useRef(null);
    // const marqueeRef = useRef(null);

    // useEffect(() => {
    //     if (!props.heroimgs || props.heroimgs.length === 0) return;
    //     const totalcontentwidth = wt * props.heroimgs.length
    //     if (wt && totalcontentwidth > 0) {
    //         setTotalcontentwidth(totalcontentwidth);
    //         setAdjustedspeed((totalcontentwidth / 500) * 2);
    //         setHeroimgs(props.heroimgs);
    //     }
    // }, [props.heroimgs]);

    // useEffect(() => {
    //     if (!totalcontentwidth || totalcontentwidth <= 0) return;

    //     const styleId = 't2-marquee-keyframes-style';

    //     // Check if a style with this ID already exists
    //     let styleEl = document.getElementById(styleId);

    //     if (!styleEl) {
    //         styleEl = document.createElement('style');
    //         styleEl.id = styleId;
    //         document.head.appendChild(styleEl);
    //     }

    //     styleEl.innerHTML = `
    //       @keyframes marquee {
    //         0% { transform: translateX(0); }
    //         100% { transform: translateX(-${totalcontentwidth}px); }
    //       }
    //     `;

    //     styleElRef.current = styleEl;

    //     // Cleanup only if this component added it
    //     return () => {
    //         const existing = document.getElementById(styleId);
    //         if (existing) {
    //             document.head.removeChild(existing);
    //         }
    //         styleElRef.current = null;
    //     };
    // }, [totalcontentwidth]);


    // return (
    //     <div
    //         ref={mainimg_ref}
    //         style={{
    //             display: 'block',
    //             justifySelf: 'center',
    //             overflow: "hidden",
    //             whiteSpace: "nowrap",
    //             justifySelf: 'center',
    //             height: wt,
    //             width: wt,
    //         }}>
    //         <div
    //             ref={marqueeRef}
    //             style={{
    //                 animation: `${adjustedspeed}s linear infinite marquee`,  // Use adjustedSpeed here
    //                 minWidth: totalcontentwidth * 2,
    //                 display: 'flex',
    //                 willChange: 'transform',
    //                 transform: 'translateX(0)', // ← add this
    //             }}
    //         >
    //             {[...heroimgs, ...heroimgs].map((img, index) => (
    //                 <img
    //                     key={index + img}
    //                     src={img}
    //                     onLoad={onload}
    //                     style={{ minWidth: wt, height: wt, objectFit: 'cover' }}
    //                 />
    //             ))}
    //         </div>

    //     </div>
    // );
};

const T2Single_WEB_and_MOBILE = ({ heroimgs, wt, br, onload, mainimg_ref, transition_css_mainimg, portrait_or_landscape, device }) => { // DONE
    // landscape only
    return <img
        ref={mainimg_ref}
        id="ilookup_imgid"
        className={"ilookup_single_img_" + portrait_or_landscape}
        onLoad={onload}
        src={heroimgs[0]}
        style={{
            width: wt,
            height: device === 'MOBILE' && portrait_or_landscape === 'landscape' ? wt : 'auto',
            borderRadius: br,
            ...transition_css_mainimg
        }}
    />
};

const T2Marquee_WEB = (props) => { // DONE
    // ACCEPT BOTH ORIENTATION, PORTRAIT AND HORIZONTAL AND SQUARE
    const { onload, wt, ht, mainimg_ref } = props

    const [adjustedspeed, setAdjustedspeed] = useState(-1)
    const [totalcontentwidth, setTotalcontentwidth] = useState(-1)
    const [heroimgs, setHeroimgs] = useState([])
    const [heroimgs_orientation_map, setHeorimgs_orientation_map] = useState({})
    const styleElRef = useRef(null);
    const marqueeRef = useRef(null);
    const screen_wt = ScreenWidth()

    useEffect(() => {
        let isCancelled = false;

        if (!props.heroimgs || props.heroimgs.length === 0) return;

        const loadImagesAndCalculate = async () => {
            const heightNum = parseInt(ht);
            const orientationMap = {}; // new: map to store orientation
            const promises = props.heroimgs.map((src, index) => {
                return new Promise((resolve) => {
                    const img = new Image();

                    img.src = src;

                    img.onload = () => {
                        const { orientation, aspectRatio } = getImageDetails(img)
                        const width = orientation === 'landscape' ? screen_wt : (heightNum * aspectRatio);
                        orientationMap[src] = orientation; // new: save orientation by src
                        resolve(width);
                    };

                    img.onerror = () => resolve(0);
                });
            });

            const widths = await Promise.all(promises);

            if (isCancelled) return;

            const totalcontentwidth = widths.reduce((acc, w) => { return acc + w }, 0);
            if (widths && totalcontentwidth > 0) {
                setTotalcontentwidth(totalcontentwidth);
                setAdjustedspeed((totalcontentwidth / 500) * 2);
                setHeroimgs(props.heroimgs);
                setHeorimgs_orientation_map(orientationMap); // new: store orientation map
            }

        };

        loadImagesAndCalculate();

        return () => {
            isCancelled = true;
        };
    }, [props.heroimgs, ht]);

    useEffect(() => {
        if (!totalcontentwidth || totalcontentwidth <= 0) return;

        const styleId = 't2-marquee-keyframes-style';

        // Check if a style with this ID already exists
        let styleEl = document.getElementById(styleId);

        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = styleId;
            document.head.appendChild(styleEl);
        }

        styleEl.innerHTML = `
          @keyframes marquee {
            from { transform: translateX(0); }
            to { transform: translateX(-${totalcontentwidth}px); }
          }
        `;

        styleElRef.current = styleEl;

        // Cleanup only if this component added it
        return () => {
            const existing = document.getElementById(styleId);
            if (existing) {
                document.head.removeChild(existing);
            }
            styleElRef.current = null;
        };
    }, [totalcontentwidth]);

    return (
        <div
            className='T2sim_marquee_web'
            ref={mainimg_ref}
            style={{
                display: 'block',
                justifySelf: 'center',
                overflow: "hidden",
                whiteSpace: "nowrap",
                justifySelf: 'center',
                overflow: 'hidden'
            }}>
            <div
                ref={marqueeRef}
                style={{
                    minWidth: totalcontentwidth * 2,
                    display: "flex",
                    animation: `${adjustedspeed}s linear infinite marquee`,  // Use adjustedSpeed here
                    willChange: "transform", // added for smoother animation
                }}
            >
                {[...heroimgs, ...heroimgs].map((img, index) => {
                    return <img
                        className='T2sim_marqueeherimg_web'
                        key={'T2Marquee_web' + index}
                        onLoad={onload}
                        src={img}
                        style={{
                            display: 'flex',
                            objectFit: 'cover',
                            height: ht,
                            width: heroimgs_orientation_map[img] === 'landscape' ? wt : 'auto',
                            maxWidth: wt
                        }}
                    />
                })}
            </div>
        </div>
    );
};

const T2Slideshow_WEB = ({ // DONE
    heroimgs,
    wt,
    ht,
    br,
    onload,
    mainimg_ref,
}) => {
    // landscape image only
    const duration = heroimgs.length * 4; // 4s per image
    return (
        <div
            ref={mainimg_ref}
            style={{
                width: wt,
                height: ht,
                borderRadius: br,
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            {heroimgs.map((img, i) => (
                <img
                    key={i}
                    src={img}
                    onLoad={onload}
                    className="slideshow-img"
                    style={{
                        height: '100%',
                        animation: `fadecycle ${duration}s infinite`,
                        animationDelay: `${i * 4}s`, // shift start for each image
                    }}
                />
            ))}

            <style>{`
          .slideshow-img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            top: 0;
            left: 0;
            opacity: 0;
          }
  
          @keyframes fadecycle {
            0% { opacity: 1; }
            33.3333% { opacity: 1; }
            50% { opacity: 0; }
            83.3333% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}</style>
        </div>
    );
};

const T2Slideshow_MOBILE = ({ // DONE
    heroimgs,
    wt,
    onload,
    mainimg_ref,
}) => {
    const duration = heroimgs.length * 4; // 4s per image
    return (
        <div
            ref={mainimg_ref}
            style={{
                overflow: "hidden",
                position: "relative",
                width: wt,
                height: wt,
            }}
        >
            {heroimgs.map((img, i) => (
                <img
                    key={i}
                    src={img}
                    onLoad={onload}
                    className="slideshow-img"
                    style={{
                        animation: `fadecycle ${duration}s infinite`,
                        animationDelay: `${i * 4}s`, // shift start for each image
                        width: wt,
                        height: wt,
                    }}
                />
            ))}

            <style>{`
          .slideshow-img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            top: 0;
            left: 0;
            opacity: 0;
          }
  
          @keyframes fadecycle {
            0% { opacity: 1; }
            33.3333% { opacity: 1; }
            50% { opacity: 0; }
            83.3333% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}</style>
        </div>
    );
};

const T2Marquee_MOBILE = (props) => { // DONE

    const { wt, onload, mainimg_ref } = props
    const [adjustedspeed, setAdjustedspeed] = useState(-1)
    const [totalcontentwidth, setTotalcontentwidth] = useState(-1)
    const [heroimgs, setHeroimgs] = useState([])
    const styleElRef = useRef(null);
    const marqueeRef = useRef(null);
    useEffect(() => {
        if (!props.heroimgs || props.heroimgs.length === 0) return;
        const totalcontentwidth = wt * props.heroimgs.length
        if (wt && totalcontentwidth > 0) {
            setTotalcontentwidth(totalcontentwidth);
            setAdjustedspeed((totalcontentwidth / 500) * 2);
            setHeroimgs(props.heroimgs);
        }
    }, [props.heroimgs]);

    useEffect(() => {
        if (!totalcontentwidth || totalcontentwidth <= 0) return;

        const styleId = 't2-marquee-keyframes-style';

        // Check if a style with this ID already exists
        let styleEl = document.getElementById(styleId);

        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = styleId;
            document.head.appendChild(styleEl);
        }

        styleEl.innerHTML = `
          @keyframes marquee {
            from { transform: translateX(0); }
            to { transform: translateX(-${totalcontentwidth}px); }
          }
        `;

        styleElRef.current = styleEl;

        // Cleanup only if this component added it
        return () => {
            const existing = document.getElementById(styleId);
            if (existing) {
                document.head.removeChild(existing);
            }
            styleElRef.current = null;
        };
    }, [totalcontentwidth]);


    return (
        <div
            ref={mainimg_ref}
            className='ilookup_marqueemobile_root'
            style={{
                display: 'block',
                justifySelf: 'center',
                overflow: "hidden",
                whiteSpace: "nowrap",
                justifySelf: 'center',
                height: wt,
                width: wt,
            }}>
            <div
                ref={marqueeRef}
                style={{
                    animation: `${adjustedspeed}s linear infinite marquee`,  // Use adjustedSpeed here
                    minWidth: totalcontentwidth * 2,
                    display: 'flex',
                    willChange: "transform", // added for smoother animation
                }}
            >
                {[...heroimgs, ...heroimgs].map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        onLoad={onload}
                        style={{ minWidth: wt, height: wt, objectFit: 'cover' }}
                    />
                ))}
            </div>

        </div>
    );

    // const wt = ScreenWidth()
    // const marqueeRef = useRef(null);
    // const totalContentWidth = heroimgs.length * parseInt(wt); // Assuming all images have the same width 'wt'
    // const adjustedSpeed = (totalContentWidth / 2500) * 20; // Adjust the factor as needed to fine-tune the speed

    // useEffect(() => {
    //     if (marqueeRef.current) {
    //         marqueeRef.current.innerHTML += marqueeRef.current.innerHTML;
    //     }
    // }, []);

    // return (
    //     <div
    //         ref={mainimg_ref}
    //         className='ilookup_marqueemobile_root'
    //         style={{
    //             display: 'block',
    //             justifySelf: 'center',
    //             overflow: "hidden",
    //             whiteSpace: "nowrap",
    //             justifySelf: 'center',
    //             aspectRatio: portrait_or_landscape === 'portrait' ? 4 / 5 : 22 / 7,
    //             height: portrait_or_landscape === 'landscape' ? wt : 'auto',
    //             width: wt,
    //             borderRadius: br,
    //         }}>
    //         <div
    //             ref={marqueeRef}
    //             className={'ilookup_marqueemobile_imgroot_' + portrait_or_landscape}
    //             style={{
    //                 animation: `${adjustedSpeed}s linear infinite marquee`,  // Use adjustedSpeed here
    //                 width: wt,
    //             }}
    //         >
    //             {heroimgs.map((img, index) => (
    //                 <img
    //                     className={'ilookup_marqueemobile_img_' + portrait_or_landscape}
    //                     key={index}
    //                     src={img}
    //                     onLoad={onload}
    //                     style={{ minWidth: wt }}
    //                 />
    //             ))}
    //         </div>

    //         <style>
    //             {`
    //                 @keyframes marquee {
    //                     from { transform: translateX(0); }
    //                     to { transform: translateX(-400%); }
    //                 }
    //             `}
    //         </style>
    //     </div>
    // );
};

const ALL_UNIQUE_DEFAULT_COUPLE_THUMBNAILS = getUniqueThumbnails(INVITATION_COUPLE_DEFAULT_IMGS_MAP)
const ALL_UNIQUE_DEFAULT_COUPLE_IMGS = getUniqueImgs(INVITATION_COUPLE_DEFAULT_IMGS_MAP)

// const testimg = 36
var transition_loaded_css = { transitionDuration: '1000ms', opacity: 1, visibility: 'visible', }
var transition_loading_css = { visibility: 'hidden', opacity: 0 }

// fontSize mobile
const title_fs_mobile = a_fs
const maintext_fs_mobile = d_fs
const subtext_fs_mobile = d_fs
const datetime_fs_mobile = d_fs
const schedule_fs_mobile = d_fs
const map_fs_mobile = e_fs
const qn_fs_mobile = d_fs
const party_fs_mobile = d_fs
const universal_padding = 20

function genQnas(fs, qnas) {
    var qnas_dom = []
    var lh = FS_LH_MAP[fs]
    if (qnas && qnas.length > 0) {
        for (let i = 0; i < qnas.length; i = i + 2) {
            qnas_dom.push(
                <div key={'dom_qnas' + i} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', flexWrap: 'wrap', padding: i === 0 ? '0px 20px 20px 20px' : '20px' }}>
                    <div style={{ fontSize: fs, fontWeight: 'bold', lineHeight: lh }}>{qnas[i]}</div>
                    <div style={{ fontSize: fs, lineHeight: lh }}>{qnas[i + 1]}</div>
                </div>
            )
        }
        return qnas_dom
    }
    return null
}

function Invitationlookup(props) {

    const device = Checkdevice()

    // dimension
    const wt = ScreenWidth()
    const latest_ht = ScreenHeight()
    const [ht, setHt] = useState(document.body.clientHeight) // use to for scaling fit text

    const WEB_TABLET_WT = device === 'TABLET' ? (wt < 600 ? 500 : wt < 800 ? 550 : 650) : 740
    const [firsttime, setFirsttime] = useState(true)
    const [itype, setItype] = useState('')

    const [css_map, setCss_map] = useState({})

    const [displayseq, setDisplayseq] = useState([]) // display sequence
    const [displaytxtmap, setDisplaytxtmap] = useState({}) // change the title for the default ones
    const [displayonoffmap, setDisplayonoffmap] = useState({}) // user can select to on off certain components
    const [ntw, setNtw] = useState(null) // name title format for web
    const [ntt, setNtt] = useState(null) // name title format for tablet
    const [ntm, setNtm] = useState(null) // name title format for mobile
    const [naw, setNaw] = useState(null) // name title anime for web
    const [nat, setNat] = useState(null) // name title anime for tablet
    const [nam, setNam] = useState(null) // name title anime for mobile, 0: animation visible, 1: hidden
    const [nameanimationdata, setNameanimationdata] = useState({ 'txt': "", 'duration': 1000 })
    const [name1, setName1] = useState('') // name
    const [name2, setName2] = useState('') // spousename
    const [date_e, setDatee] = useState(null)
    const [date_w, setDatew] = useState(null)
    const [countdown, setCountdown] = useState(null)
    const [dt_type, setDt_type] = useState('')
    const [location, setLocation] = useState('')
    const [location_map, setLocation_map] = useState({})
    const [mapiframe, setMapiframe] = useState(null)
    const [mapmode, setMapmode] = useState(null)
    const [maintext, setMaintext] = useState('')
    const [subtext, setSubtext] = useState('')
    const [lat, setLat] = useState(0)
    const [long, setLong] = useState(0)
    const [locurl, setLocurl] = useState('')
    const [locdescript, setLocdescript] = useState('')
    const [time, setTime] = useState('')
    const [images, setImages] = useState([])
    const [imgcss_map, setImagecss_map] = useState({})
    // {
    //     'mainimg': {
    //         'borderRadius': true
    //         'boxShadow': true
    //     },
    // }
    const [svgoverlay_map, setSvgoverlay_map] = useState({})
    // {
    //      'svgitem' : 0, 0 - 'we do', 1 - heart, ... 
    //      'color': '#ffffff', 
    //      'mode': 0,  0 - direct appear, 1 - animate once, 2 - forever animate 
    //      'replay' : false,
    //      'svgposition':'center' // flex-start, center, flex-end - svg position within image.
    // }
    const [templatetype, setTemplatetype] = useState(-1)
    const [prebuildtemplatedesign_map, setPrebuildtemplatedesign_map] = useState({})
    const [templatecolor, setTemplatecolor] = useState(-1)
    const [templatebgcolor, setTemplatebgcolor] = useState(-1)// eslint-disable-line
    const [textures, setTextures] = useState(['', '']) // card, bg
    const [qnas, setQnas] = useState([])
    const [styletype, setStyletype] = useState(-1)
    const [styleorientation, setStyleorientation] = useState(-1)
    const [styleorientationmobile, setStyleorientationmobile] = useState(-1)
    const [stylesep, setStylesep] = useState('')
    const [styleformation, setStyleformation] = useState(0)
    const [styleformationmobile, setStyleformationmobile] = useState(0)
    const [styleborder, setStyleborder] = useState(0)
    const [styleborderwt, setStyleborderwt] = useState(null) // true or false
    const [styleborderbr, setStyleborderbr] = useState(null) // true or false
    const [stylebordercolor, setStylebordercolor] = useState('') // string
    const [contacts, setContacts] = useState([])
    const [guestid, setGuestid] = useState('')

    const [ff, setFf] = useState('')

    const [priff, setPriff] = useState('')
    const [secff, setSecff] = useState('')

    const [locationff, setLocationff] = useState(-1) // derieved state from pri or secff
    const [btmbarff, setBtmbarff] = useState(-1) // derieved state from pri or secff
    const [datetimeff, setDatetimeff] = useState(-1) // derieved state from pri or secff
    const [notiff, setNotiff] = useState(-1) // derieved state from pri or secff

    const [fc, setFc] = useState('')
    const [schedules, setSchedules] = useState([])
    const [rsvpactive, setRsvpactive] = useState(false) // bool to determine whether there is RSVP or not
    const [showrsvpdom, setShowrsvpdom] = useState(false) // bool to open rsvp
    const [socialmedialinks, setSocialmedialinks] = useState([])
    // const [alticlinks, setAlticlinks] = useState([]) // INACTIVE
    const [promote, setPromote] = useState([])
    const [showgallery, setShowgallery] = useState(false)
    const [showcontact, setShowcontact] = useState(false)
    const [showitinerary, setShowitinerary] = useState(false)
    const [wproposal, setWproposal] = useState('')
    const [whowwemet, setHowwemet] = useState('')
    const [registry, setRegistry] = useState({ url: '', urls: [] })
    const [showmore, setShowmore] = useState(false)
    const [menumore, setMenumore] = useState([])

    // party
    const [party, setParty] = useState([])
    const [partyproperties, setPartyproperties] = useState({})
    const [singlepartymemberdata, setSinglepartymemberdata] = useState({})
    const [showparty, setShowparty] = useState(false)

    const [currguestid_guestinfo_map, setCurrguestid_guestinfo_map] = useState({})
    const [grpmemberid_guestqnsarr_map, setGrpmemberid_guestqnsarr_map] = useState({})
    const [grpmemberid_guestinfo_map, setGrpmemberid_guestinfo_map] = useState({})
    const [grpleader, setGrpleader] = useState(false)
    const [guestid_defaultqnstate_map, setGuestid_defaultqnstate_map] = useState({})
    const [rsvp_obj, setRsvp_obj] = useState({})

    // for opening
    const [openingnames, setOpeningnames] = useState([])
    const [openingtype, setOpeningtype] = useState('')
    const [openingobjs, setOpeningobjs] = useState([]) // store convo obj
    const [openingstoryobjs, setOpeningstoryobjs] = useState('') // store story obj
    const [animationtype, setAnimationtype] = useState('')
    const [animationobjs, setAnimationobjs] = useState([])
    const [openingclosing, setOpeningclosing] = useState(0)

    const [gtpw, setGtpw] = useState(false)
    const [showopening, setShowopening] = useState(false)

    // main image detection
    const [mainimageloaded, setMainimageloaded] = useState(false)
    const onImageLoaded = () => setMainimageloaded(true)

    // template image detection
    const [templateimageloaded, setTemplateimageloaded] = useState(false)

    const [id_bgstylea_map, setId_bgstylea_map] = useState({})
    const [id_bgstyleb_map, setId_bgstyleb_map] = useState({})

    const [showregistry, setShowregistry] = useState(false)

    const [showpromote, setShowpromote] = useState(false) // show promote modal

    const [showshare, setShowshare] = useState(false) // show share modal

    const [rsvptype, setRsvptype] = useState('') // google or default
    const [rsvpalt, setRsvpalt] = useState(['', ''])

    const [mobilepreloaded, setMobilepreloaded] = useState(false) // last updated here
    const [showtitle, setShowtitle] = useState(false)

    const [pagedownbtnappear, setPagedownbtnappear] = useState(true) // floating down arrow on mobile

    const [menutype, setMenutype] = useState('none') // none, btmnavbar, stickytopnav, menu, btmnavbarwithouticon,
    const [menuicongate, setMenuicongate] = useState(false)
    const [menuattr_map, setMenuattr_map] = useState({})
    const [menuitems, setMenuitems] = useState({})
    const [menuseq, setMenuseq] = useState([])

    const [notificationbool, setNotificationbool] = useState(null)
    const [notificationtitle, setNotificationtitle] = useState('')
    const [notificationtxt, setNotificationtxt] = useState('')

    const [notiexpand, setNotiexpand] = useState(false)

    const [startrunsvg, setStartrunsvg] = useState(false)
    const [svgstate, setSvgstate] = useState('PLAYING') // PLAYING, PAUSE

    const [heroimglayout, setHeroimglayout] = useState('') // single, marquee, slideshow
    const [heroimglayout_map, setHeroimglayout_map] = useState({})
    const [heroimgattr_map, setHeroimgattr_map] = useState({})
    const [heroimgdevice_map, setHeroimgdevice_map] = useState({})
    const [heroimgs, setHeroimgs] = useState([])

    const mainimg_ref = useRef(null)
    const startimg_ref = useRef(null)
    const pagescrolldown_ref = useRef(null) // mobile only, scroll down btn ref
    const rsvp_ref = useRef(null) // rsvp btn click

    const devicedim = { 'WEB': 30, 'TABLET': 29, 'MOBILE': 28 }[device]
    const GENERALICON_CSS = { width: devicedim, height: devicedim, display: 'flex', margin: '4px 0px' }
    const ICON_MAP = {
        'RSVP': iconwrapper(RSVP_ICON, GENERALICON_CSS),
        'Gallery': iconwrapper(GALLERY_ICON, GENERALICON_CSS),
        'Itinerary': iconwrapper(ITINERARY_ICON, GENERALICON_CSS),
        'Contact': iconwrapper(RSVPTELEPHONE_ICON, GENERALICON_CSS),
        'Seatings': iconwrapper(SEATINGS_ICON, GENERALICON_CSS),
        'Guestbook': iconwrapper(GUESTBOOK_ICON, GENERALICON_CSS),
        'More': iconwrapper(SMALLERMORE_ICON, GENERALICON_CSS),
        'Share': iconwrapper(SOCIALMEDIA_ICON, GENERALICON_CSS),
        'Promote': iconwrapper(PROMOTE_ICON, GENERALICON_CSS),
        'Registry': iconwrapper(REGISTRY_ICON, GENERALICON_CSS),
    }

    const PARAMS_MEDIA_MAP = {

        'Telegram': {
            // 'icon': <svg style={iconcss} viewBox={vb_} version={v_} xmlns={x_}><path d="M834.24 127.872a95.168 95.168 0 0 0-29.856 7.136h-0.128c-9.12 3.616-52.48 21.856-118.4 49.504l-236.224 99.488c-169.504 71.36-336.128 141.632-336.128 141.632l1.984-0.768s-11.488 3.776-23.488 12a64.96 64.96 0 0 0-18.752 18.144c-5.888 8.64-10.624 21.856-8.864 35.52 2.88 23.104 17.856 36.96 28.608 44.608 10.88 7.744 21.248 11.36 21.248 11.36h0.256l156.256 52.64c7.008 22.496 47.616 156 57.376 186.752 5.76 18.368 11.36 29.856 18.368 38.624 3.392 4.48 7.36 8.224 12.128 11.232a35.808 35.808 0 0 0 7.872 3.392l-1.6-0.384c0.48 0.128 0.864 0.512 1.216 0.64 1.28 0.352 2.144 0.48 3.776 0.736 24.736 7.488 44.608-7.872 44.608-7.872l1.12-0.896 92.256-84 154.624 118.624 3.52 1.504c32.224 14.144 64.864 6.272 82.112-7.616 17.376-13.984 24.128-31.872 24.128-31.872l1.12-2.88 119.488-612.128c3.392-15.104 4.256-29.248 0.512-42.976a57.824 57.824 0 0 0-24.992-33.504 59.904 59.904 0 0 0-34.144-8.64z m-3.232 65.6c-0.128 2.016 0.256 1.792-0.64 5.664v0.352l-118.368 605.76c-0.512 0.864-1.376 2.752-3.744 4.64-2.496 1.984-4.48 3.232-14.88-0.896l-189.12-144.992-114.24 104.128 24-153.28 308.992-288c12.736-11.84 8.48-14.336 8.48-14.336 0.896-14.528-19.232-4.256-19.232-4.256l-389.632 241.376-0.128-0.64-186.752-62.88v-0.128l-0.48-0.096a8.64 8.64 0 0 0 0.96-0.384l1.024-0.512 0.992-0.352s166.752-70.272 336.256-141.632c84.864-35.744 170.368-71.744 236.128-99.52 65.76-27.616 114.368-47.872 117.12-48.96 2.624-1.024 1.376-1.024 3.264-1.024z" p-id="7705"></path></svg>,
            'icon': iconwrapper(THINTELEGRAM_ICON, GENERALICON_CSS)
        },
        'Whatsapp': {
            // 'icon': <svg style={iconcss} viewBox={vb_} version={v_} xmlns={x_}><path d="M636.013714 556.544q7.460571 0 55.734857 25.161143t51.126857 30.281143q1.170286 2.852571 1.170286 8.557714 0 18.870857-9.728 43.446857-9.142857 22.308571-40.594286 37.449143t-58.294857 15.140571q-32.548571 0-108.544-35.401143-56.027429-25.746286-97.133714-67.437714t-84.553143-105.691429q-41.179429-61.147429-40.594286-110.884571l0-4.534857q1.682286-52.004571 42.276571-90.258286 13.677714-12.580571 29.696-12.580571 3.437714 0 10.313143 0.877714t10.825143 0.877714q10.825143 0 15.140571 3.730286t8.850286 15.725714q4.534857 11.410286 18.870857 50.322286t14.262857 42.861714q0 11.995429-19.748571 32.841143t-19.748571 26.550857q0 4.022857 2.852571 8.557714 19.456 41.691429 58.294857 78.262857 32.036571 30.281143 86.308571 57.709714 6.875429 4.022857 12.580571 4.022857 8.557714 0 30.866286-27.721143t29.696-27.721143zM520.009143 859.428571q72.557714 0 139.117714-28.598857t114.541714-76.580571 76.580571-114.541714 28.598857-139.117714-28.598857-139.117714-76.580571-114.541714-114.541714-76.580571-139.117714-28.598857-139.117714 28.598857-114.541714 76.580571-76.580571 114.541714-28.598857 139.117714q0 116.004571 68.534857 210.285714l-45.129143 133.12 138.313143-44.032q90.258286 59.465143 197.12 59.465143zM520.009143 69.705143q87.405714 0 167.131429 34.304t137.435429 92.013714 92.013714 137.435429 34.304 167.131429-34.304 167.131429-92.013714 137.435429-137.435429 92.013714-167.131429 34.304q-111.396571 0-208.603429-53.686857l-238.299429 76.580571 77.677714-231.424q-61.732571-101.741714-61.732571-222.281143 0-87.405714 34.304-167.131429t92.013714-137.435429 137.435429-92.013714 167.131429-34.304z" p-id="8567"></path></svg>,
            'icon': iconwrapper(THINWECHAT_ICON, GENERALICON_CSS)
        },
        'WeChat': {
            // 'icon': <svg style={iconcss} viewBox={vb_} version={v_} xmlns={x_}><path d="M234.667 320A42.667 42.667 0 1 0 320 320a42.667 42.667 0 1 0-85.333 0zM448 320a42.667 42.667 0 1 0 85.333 0A42.667 42.667 0 1 0 448 320zM896 807.68a248.107 248.107 0 0 0 95.36-192c0-133.973-114.133-244.48-261.12-260.907C704 208 558.293 96 384 96 189.867 96 32 234.667 32 405.333A292.053 292.053 0 0 0 147.2 634.24l-28.8 103.893a32 32 0 0 0 46.293 36.48l128-70.613a398.293 398.293 0 0 0 91.734 10.667c10.88 0 21.333 0 32.426-1.494 44.16 96.64 151.68 164.907 277.334 164.907a337.707 337.707 0 0 0 75.52-8.533L874.24 927.36a32 32 0 0 0 46.293-36.48z m-203.307 6.4A241.067 241.067 0 0 1 481.92 701.867l-12.587-29.44-7.68-30.934a170.667 170.667 0 0 1-2.346-26.453c0-103.467 93.44-188.8 213.333-198.187H704a275.2 275.2 0 0 1 31.787 2.987c109.44 16.853 192 98.133 192 195.84a188.587 188.587 0 0 1-85.334 154.027 32 32 0 0 0-12.586 34.773l8.533 30.72-49.067-27.52a32 32 0 0 0-23.893-2.773 272.64 272.64 0 0 1-72.107 9.386zM384 650.667A334.08 334.08 0 0 1 296.32 640a32.213 32.213 0 0 0-23.893 2.987l-71.894 39.68 14.294-51.627a32 32 0 0 0-12.587-34.773A232.747 232.747 0 0 1 96 405.333C96 270.08 225.28 160 384 160c137.813 0 253.227 82.987 281.387 193.28-151.68 12.587-270.72 125.013-270.72 261.76a232.32 232.32 0 0 0 2.986 34.987zM611.627 554.667H608a32 32 0 0 0-32 32 32 32 0 1 0 35.627-32zM746.667 586.667a32 32 0 1 0 64 0 32 32 0 1 0-64 0z" p-id="6460"></path></svg>,
            'icon': iconwrapper(THINWECHAT_ICON, GENERALICON_CSS)
        },
        'Instagram': {
            // 'icon': <svg style={iconcss} viewBox={vb_} version={v_} xmlns={x_}><path d="M512.1 282c-127.2 0-229.8 102.6-229.8 229.8s102.6 229.8 229.8 229.8S741.9 639 741.9 511.8 639.3 282 512.1 282z m0 379.2c-82.2 0-149.4-67-149.4-149.4s67-149.4 149.4-149.4 149.4 67 149.4 149.4-67.2 149.4-149.4 149.4z m292.8-388.6c0 29.8-24 53.6-53.6 53.6-29.8 0-53.6-24-53.6-53.6s24-53.6 53.6-53.6 53.6 24 53.6 53.6z m152.2 54.4c-3.4-71.8-19.8-135.4-72.4-187.8-52.4-52.4-116-68.8-187.8-72.4-74-4.2-295.8-4.2-369.8 0-71.6 3.4-135.2 19.8-187.8 72.2s-68.8 116-72.4 187.8c-4.2 74-4.2 295.8 0 369.8 3.4 71.8 19.8 135.4 72.4 187.8s116 68.8 187.8 72.4c74 4.2 295.8 4.2 369.8 0 71.8-3.4 135.4-19.8 187.8-72.4 52.4-52.4 68.8-116 72.4-187.8 4.2-74 4.2-295.6 0-369.6zM861.5 776c-15.6 39.2-45.8 69.4-85.2 85.2-59 23.4-199 18-264.2 18s-205.4 5.2-264.2-18c-39.2-15.6-69.4-45.8-85.2-85.2-23.4-59-18-199-18-264.2s-5.2-205.4 18-264.2c15.6-39.2 45.8-69.4 85.2-85.2 59-23.4 199-18 264.2-18s205.4-5.2 264.2 18c39.2 15.6 69.4 45.8 85.2 85.2 23.4 59 18 199 18 264.2s5.4 205.4-18 264.2z" fill="" p-id="6208"></path></svg>,
            'icon': iconwrapper(THININSTAGRAM_ICON, GENERALICON_CSS)
        },
        'Number': {
            // 'icon': <svg style={iconcss} viewBox={vb_} version={v_} xmlns={x_}><path d="M908.04764 691.466418l-12.631692-16.232706-0.464581-0.493234c-4.123924-4.326539-15.82543-16.231683-34.96228-32.668027-22.883173-19.688411-63.711044-48.726771-66.932412-50.876738l-57.118905-34.496675c-10.483772-5.256724-21.605064-6.358825-29.096688-6.358825-8.131191 0-16.145725 1.306762-23.144116 3.773953-24.710798 8.624425-47.767933 47.565319-54.185087 59.325154-2.963495 5.430686-6.214539 11.935843-9.003048 17.656125l-0.899486 1.801019c-3.484358 6.940063-7.377014 14.721283-11.499915 22.300912-4.066619 7.317663-12.775978 14.751982-21.605064 14.751982-2.728134 0-5.28333-0.668219-7.750521-2.061962-38.274722-21.982664-83.60207-50.438763-129.831974-94.985328-52.1528-50.294476-83.108836-90.047876-100.241029-128.842437-1.044796-2.657526-0.929162-14.693654 5.865591-18.048051 9.379625-4.675486 17.016559-7.738241 23.752983-10.468422l1.568728-0.682545c9.698896-3.934612 18.903535-7.652284 29.386284-14.039761 4.529153-2.918469 6.940063-4.253884 9.002025-5.41636l1.044796-0.623193c3.774977-2.047636 7.317663-4.00829 18.178011-11.32493 0.465604-0.334621 2.439562-1.960655 4.530177-3.746324l6.968715-6.302543c18.207687-17.552771 24.189935-43.38409 15.216563-65.742307l-3.13541-9.045003c-0.058328-0.233314-11.615549-27.122731-30.142507-59.078537-9.002025-15.46318-22.650883-36.023448-34.731012-52.342112-32.638351-44.008306-62.838164-58.077743-62.983473-58.134025-0.319272-0.174985-8.159844-4.341888-12.979616-6.53381-19.688411-8.42181-41.933041-8.117888-61.794391 0.594541-29.676903 11.150968-47.88459 26.366508-67.252707 42.541909l-4.240581 3.628644c-57.496505 48.001247-88.639806 110.62247-81.293491 163.515121 11.021008 79.987752 103.420441 243.256256 223.349881 358.830505 119.871111 115.485221 288.670585 204.25601 371.112226 214.739782 6.243191 0.813528 12.661368 1.219781 19.078521 1.219781 59.557444 0 106.020662-36.32737 139.791813-67.980277 16.84055-15.796778 39.084157-41.84606 50.930973-67.630307C920.361083 749.341546 925.355841 716.353225 908.04764 691.466418M293.157271 468.464461c20.559245 46.505173 55.638181 92.212168 113.657596 148.08264 50.699706 48.929386 100.095719 80.030731 141.765771 103.987353 11.963473 6.822382 24.769127 10.278087 37.953404 10.278087 33.917484 0 61.909002-23.229051 74.687026-46.257533 4.792143-8.741082 9.029654-17.248849 13.675464-26.598798l1.917676-3.947915c2.148943-4.211928 4.093225-8.132214 5.865591-11.472286 9.610892-17.33583 18.759249-27.818579 22.737864-31.419594 1.104147-0.057305 2.670829-0.027629 3.571339 0.060375l50.730405 30.664394 0.841158 0.579191c12.310374 8.798387 42.773176 30.897707 59.849086 45.620014 14.895245 12.777001 24.50716 22.273283 27.64257 25.351388 0.553609 0.578168 0.901533 0.956791 1.251503 1.188058l9.289574 11.907191c0.668219 2.496867 0 11.847839-3.773953 20.123316-8.217149 17.831111-25.206078 37.401842-37.285185 48.727795-38.736233 36.239366-67.921949 51.658544-97.656157 51.658544-3.920286 0-7.986905-0.261966-12.081153-0.813528-63.014172-7.984858-221.591841-87.291089-336.758814-198.246133C256.249687 537.301246 174.100712 384.994398 165.73723 324.522118c-4.41352-31.885198 19.165502-74.512041 60.051701-108.662839l4.384867-3.615341c17.771759-14.94027 29.532617-24.798802 51.049676-32.929993 3.716648-1.567705 6.706749-2.365884 9.204639-2.365884 1.771343 0 3.659343 0.376577 5.285377 1.060145 2.148943 1.016143 5.749958 2.88777 7.956206 4.078899l1.916653 0.973164c0.203638 0.102331 19.572778 10.235109 41.815361 40.260959 11.092639 14.868639 23.231097 33.190937 31.012318 46.607504 8.537444 14.810311 17.046235 31.187303 25.263383 48.697095 0.320295 0.654916 0.581238 1.220804 0.813528 1.671059l2.671852 8.02886c0.203638 0.478907 0.260943 0.740874 0.319272 0.740874-0.116657 0.144286-0.435928 0.477884-0.98749 1.016143l-1.771343 1.755993c-0.754177 0.712221-1.567705 1.481747-2.032286 1.989307-7.695263 5.081739-10.338463 6.532787-13.06762 8.116865-2.671852 1.452071-5.92392 3.238764-12.370749 7.316639-5.982248 3.659343-11.993149 6.098905-20.529569 9.540284-8.450463 3.396353-17.683754 7.202029-29.068036 12.81998C286.769794 391.83213 281.309432 441.735703 293.157271 468.464461" p-id="4151"></path></svg>,
            'icon': iconwrapper(CONTACT_ICON, GENERALICON_CSS)
        },
        'Facebook': {
            'icon': iconwrapper(THINFACEBOOK_ICON, GENERALICON_CSS)
        },
        'Registery': {
            'icon': iconwrapper(REGISTRY_ICON, GENERALICON_CSS)
        },
    }

    // guestid_guestinfo_map
    function upateStates(card, currguestid_guestinfo_map, grpmemberid_guestqnsarr_map, grpmemberid_guestinfo_map, rsvp_obj, grpleader, guestid_defaultqnstate_map) {
        const {
            itype, displayseq, displaytxtmap, displayonoffmap, css_map, specificcompff_map, ntw, ntt, ntm, naw, nat, nam, nameanimationdata, name, spousename, dt_type, date_e, date_w, countdown, location, location_map, mapmode, maintext, subtext, lat, long, locurl, locdescript, time, images, prebuildtemplatedesign_map, templatetype, templatebgcolor, templatecolor, templateattr_map, textures, qnas, styletype, styleborder, styleborderwt, styleborderbr, stylebordercolor, stylesep, ff, ffobj, fc, schedules, rsvpactive,
            styleorientation, styleorientationmobile, styleformation, styleformationmobile,
            openingnames, openingclosing, openingtype, openingobjs, openingstoryobjs, animationtype, animationobjs, socialmedialinks, alticlinks, promote, wproposal, whowwemet,
            rsvpalt, menutype, menuicongate, menuattr_map, menuitems, menuseq, contacts, notificationbool, notificationtitle, notificationtxt, rsvptype,
            menumore,
            // svgoverlay_map, imgcss_map,
            registry, party, partyproperties,
            heroimgattr_map, heroimglayout, heroimglayout_map,
            heroimgdevice_map
            // titletext
        } = card

        console.log('card', card)

        setItype(itype)
        setDisplayseq(displayseq)
        setDisplaytxtmap(displaytxtmap)
        setDisplayonoffmap(displayonoffmap)
        setCss_map(css_map)
        setName1(name)
        setName2(spousename)
        setWproposal(wproposal)
        setHowwemet(whowwemet)
        setDt_type(dt_type)
        setRsvpalt(rsvpalt)
        setRsvptype(rsvptype)
        setNtw(ntw)
        setNtt(ntt)
        setNtm(ntm)
        setNaw(naw)
        setNat(nat)
        setNam(templatetype === 2 ? 1 : 0) // name animation - 0 = true, 1 = false, in template 2 theres no animation
        setNameanimationdata(nameanimationdata)

        // none, btmnavbar, stickytopnav, menu, btmnavbarwithouticon,
        setMenutype(menutype)
        setMenuicongate(menuicongate)

        setMenuattr_map(JSON.parse(JSON.stringify(menuattr_map)))
        setMenuitems(menuitems)
        setGuestid_defaultqnstate_map(guestid_defaultqnstate_map)
        setMenumore(menumore)
        setRegistry(registry)

        let local_party = JSON.parse(JSON.stringify(party))
        for (let i = 0; i < local_party.length; i++) {
            if (local_party[i].photo === 'invitation/party/f1.png' || local_party[i].photo === 'invitation/party/m1.png') {
                local_party[i].photo = S3CLOUD_CLOUDFRONT_ASSET + local_party[i].photo
            }
            else {
                local_party[i].photo = S3CLOUD_CLOUDFRONT + local_party[i].photo
            }
        }
        setParty(local_party)

        // setPartyproperties(JSON.stringify(JSON.parse(partyproperties)))
        setPartyproperties(partyproperties)

        var urlhandler = props.match.params.invitationlookup.toLowerCase()
        var passcode = props.match.params.passcode
        var guestuid = props.match.params.guestuid

        if (rsvpactive
            && rsvptype === 'default'
            && passcode && passcode.length > 0
            && urlhandler && urlhandler.length > 0
            && guestuid && guestuid.length > 0) { // if user enter website without guestid, hide rsvp
            setMenuseq(menuseq)
        }
        else {
            if (rsvptype === 'google' && rsvpactive && rsvpalt && rsvpalt.length === 2) {
                setMenuseq(menuseq)
            }
            else {
                var new_menuseq = menuseq.slice()
                let indexToRemove = new_menuseq.indexOf('RSVP');
                if (indexToRemove !== -1) {
                    new_menuseq.splice(indexToRemove, 1);
                }
                setMenuseq(new_menuseq)
            }
        }

        setContacts(contacts)

        setDatee(date_e)
        setDatew(date_w)
        setCountdown(countdown)

        setLocation(location)
        setLocation_map(location_map)
        setMapmode(mapmode)

        setLocurl(locurl)
        setLocdescript(locdescript)

        setNotificationbool(notificationbool)
        setNotificationtitle(notificationtitle)
        setNotificationtxt(notificationtxt)

        // maintext start 
        var local_maintext = maintext.split("\n");
        if (maintext.length === 0) {
            setMaintext(null)
        }
        else {
            for (let i = 0; i < local_maintext.length; i++) local_maintext[i] = <span key={i + 'maxllaks4' + local_maintext[i]}>{local_maintext[i]}</span>
            setMaintext(local_maintext)
        }
        // maintext end 

        // subtext start 
        var local_subtext = subtext.split("\n");
        if (subtext.length === 0) {
            setSubtext(null)
        }
        else {
            for (let i = 0; i < local_subtext.length; i++) local_subtext[i] = <span key={i + 'maxllaks423' + local_subtext[i]}>{local_subtext[i]}</span>
            setSubtext(local_subtext)
        }

        // subtext end 

        if (typeof lat === 'string' && typeof long === 'string') { setLat(lat); setLong(long); }
        setTime(time)

        // check whether the main images are default images
        let new_images = (images && images.length > 0) ? images.slice() : []
        if (new_images.length > 0) {
            if (!(ALLDEFAULTIMGS.includes(new_images[0]) && ALLDEFAULTIMGS.includes(new_images[1]))) {
                // let it remain unchange
                for (let i = 0; i < 2; i++) {
                    if (new_images[i].indexOf(S3CLOUD_CLOUDFRONT) !== -1) {
                        new_images[i] = new_images[i]
                    }
                    else {
                        new_images[i] = getS3fullpath_withbucketname('USER_INVITATIONCARD_IMG', new_images[i])
                    }
                }
            }

            for (let i = 2; i < new_images.length; i++) {
                new_images[i] = getS3fullpath_withbucketname('USER_INVITATIONCARD_IMG', new_images[i])
            }

            setImages(new_images)
        }
        else {
            setImages([])
        }

        setTemplatetype(templatetype)
        setPrebuildtemplatedesign_map(JSON.parse(JSON.stringify(prebuildtemplatedesign_map)))
        // setTemplatecolor(templatecolor)
        setTemplatebgcolor(templatebgcolor) // currently not in use, used to be use in t2
        setTemplatecolor(templateattr_map[templatetype]['templatecolor'])
        setTextures(textures)
        setQnas(qnas)
        setGtpw(false) // determined based on message
        setStyletype(styletype)
        setStyleorientation(styleorientation)
        setStyleorientationmobile(styleorientationmobile)
        setStylesep(templatetype === 1 ? stylesep : prebuildtemplatedesign_map[2]['stylesep'])
        setStyleformation(styleformation ? styleformation : 0)
        setStyleformationmobile(styleformationmobile ? styleformationmobile : 0)
        setStyleborder(styleborder)
        setStyleborderwt(styleborderwt)
        setStyleborderbr(styleborderbr)
        setStylebordercolor(stylebordercolor)
        setFf(ff)

        const { priff, secff } = ffobj
        setPriff(priff)
        setSecff(secff)

        setLocationff(ffobj[specificcompff_map['location']])
        setBtmbarff(ffobj[specificcompff_map['btmbar']])
        setDatetimeff(ffobj[specificcompff_map['datetime']])
        setNotiff(ffobj[specificcompff_map['noti']])

        setFc(fc)
        setSchedules(schedules)

        setRsvpactive(rsvpactive)
        // setAlticlinks(alticlinks)
        setPromote(promote)
        setOpeningnames(openingnames)
        setOpeningclosing(openingclosing)
        setOpeningtype(openingtype)
        setShowopening(openingtype === 'Empty' ? false : true)


        setOpeningobjs(openingobjs)
        setOpeningstoryobjs(openingstoryobjs)
        setAnimationtype(animationtype)
        setAnimationobjs(animationobjs)
        setSocialmedialinks(socialmedialinks) // Share links


        setCurrguestid_guestinfo_map(currguestid_guestinfo_map)
        setGrpmemberid_guestqnsarr_map(grpmemberid_guestqnsarr_map)
        setGrpmemberid_guestinfo_map(grpmemberid_guestinfo_map)
        setRsvp_obj(rsvp_obj)
        setGrpleader(grpleader)

        // hero images
        setHeroimglayout(heroimglayout)
        setHeroimglayout_map(JSON.parse(JSON.stringify(heroimglayout_map)))
        setHeroimgattr_map(JSON.parse(JSON.stringify(heroimgattr_map)))
        setHeroimgdevice_map(JSON.parse(JSON.stringify(heroimgdevice_map)))
        setHeroimgs(heroimglayout_map[heroimglayout + '_' + templatetype].map(({ img }) => {
            return ALL_UNIQUE_DEFAULT_COUPLE_IMGS.includes(img)
                ? S3CLOUD_CLOUDFRONT_ASSET + 'couple/' + img
                : S3CLOUD_CLOUDFRONT + img
            // : getS3fullpath_withbucketname('USER_INVITATIONCARD_IMG', img)
        }))

        setSvgoverlay_map(JSON.parse(JSON.stringify(heroimgattr_map[templatetype]['svgoverlay_map'])))
        setImagecss_map(JSON.parse(JSON.stringify(heroimgattr_map[templatetype]['css_map'])))

    }

    function handleScroll() {
        setPagedownbtnappear(window.pageYOffset > 1 ? false : true)
    }

    useEffect(() => {
        if (firsttime) {
            props.hidetopbar(true)
            window.scrollTo(0, 0)
            var urlhandler = props.match.params.invitationlookup.toLowerCase()
            var passcode = props.match.params.passcode
            var gallerygate = props.match.params.gallery // boolean
            var guestuid = props.match.params.guestuid

            var url
            var data
            if (
                urlhandler && urlhandler.length > 0 && urlhandler.length < 100 &&
                passcode && passcode.length > 0 && passcode.length < 100 &&
                guestuid && guestuid.length > 0 && guestuid.length < 100
            ) {
                url = INVITATION_LOOKUP_GTPASSGTUID
                data = { urlhandler, passcode, guestuid }
            }
            else if (
                urlhandler && urlhandler.length > 0 && urlhandler.length < 100 &&
                passcode && passcode.length > 0 && passcode.length < 100 &&
                !guestuid
            ) {
                url = INVITATION_LOOKUP_GTPASS
                data = { urlhandler, passcode }

            }
            else {
                url = INVITATION_LOOKUP
                data = { urlhandler, passcode }
            }

            setShowgallery(gallerygate === 'true' ? true : false)

            try {
                axios({ method: 'POST', url: url, data: data })
                    .then((result) => {
                        const { message, card, currguestid_guestinfo_map, grpmemberid_guestqnsarr_map, grpmemberid_guestinfo_map, rsvp_obj, grpleader, guestid_defaultqnstate_map } = result.data
                        if (message === 'SUCCESS') {
                            setGuestid(guestuid)
                            upateStates(card, currguestid_guestinfo_map, grpmemberid_guestqnsarr_map, grpmemberid_guestinfo_map, rsvp_obj, grpleader, guestid_defaultqnstate_map)
                        }
                        else if (message === 'GTPASSCODE') setGtpw(true)
                        else {
                            props.history.push('/')
                        }
                    })
                    .catch((e) => {
                        console.log('e1', e)
                        // props.history.push('/')
                    })
            }
            catch (e) {
                console.log('e', e)
                //  props.history.push('/')
            }

            if (device === 'MOBILE') {
                window.removeEventListener('scroll', handleScroll);
                window.addEventListener('scroll', handleScroll, { passive: true });
            }
            setFirsttime(false)

        }
        return () => {
            props.hidetopbar(false)
            if (device === 'MOBILE') {
                window.removeEventListener('scroll', handleScroll);
            }
        }
    }, [])

    useEffect(() => {
        if (document.getElementById('ilookupt1')) {
            document.getElementById('ilookupt1').style.position = !showtitle ? 'fixed' : ''
            document.getElementById('ilookupt1').style.overflowY = !showtitle ? 'hidden' : ''
        }
    }, [showtitle, document.getElementById('ilookupt1')])

    useEffect(() => {
        if (showrsvpdom) {
            setLastcapturePosition(scrollPosition)

        }
        else {
            if (document.getElementById('ilookupt1')) {
                document.getElementById('ilookupt1').style.position = ''
                window.scrollTo(0, lastcapturePosition)
            }
        }
        // window.scrollTo(0, 0)
    }, [showrsvpdom, document.getElementById('ilookupt1')])

    useEffect(() => {
        if (mainimageloaded) { setTemplateimageloaded(true) }
    }, [mainimageloaded])

    useEffect(() => {
        const imgElCurrent = mainimg_ref.current;
        if (imgElCurrent) {
            imgElCurrent.addEventListener('load', onImageLoaded, { passive: true });
            return () => imgElCurrent.removeEventListener('load', onImageLoaded);
        }
    }, [mainimg_ref])

    useEffect(() => {
        updateBg()
    }, [templateimageloaded])

    useEffect(() => {
        // if ht and latest_ht gt big different we need to rerender textfit.
        var curr_ratio = latest_ht / ht
        if (curr_ratio > 1.25) { setHt(latest_ht) }
        updateBg()
    }, [latest_ht])

    useEffect(() => {
        if (templatecolor) {
            document.body.style = `background: ${templatecolor};`;
        }
        return () => {
            document.body.style = `background: "";`;
        }
    }, [templatecolor])

    const [scrollPosition, setScrollPosition] = useState(0);
    const [lastcapturePosition, setLastcapturePosition] = useState(0)
    useEffect(() => {
        function handleScroll() {
            setScrollPosition(window.scrollY);
        }

        window.addEventListener('scroll', handleScroll);

        // cleanup function to remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (location_map && location_map['maptype'] && location_map['maptype'] === 'GOOGLE') {

            const { googleiframesrc } = location_map

            const parseIframeAttributes = (iframeString) => {
                // Use a DOMParser to parse the iframe string
                const parser = new DOMParser();
                const doc = parser.parseFromString(iframeString, "text/html");
                const iframeElement = doc.querySelector("iframe");

                // Extract attributes from the iframe element and convert them to an object
                const attributes = {};
                Array.from(iframeElement.attributes).forEach((attr) => { attributes[attr.name] = attr.value; });

                return { width: '100%', height: 150, src: attributes.src, frameBorder: '' };
            };

            const local_googleiframesrc = parseIframeAttributes(googleiframesrc)

            setMapiframe(local_googleiframesrc)

        }
    }, [location_map])

    useEffect(() => {
        if (device === 'MOBILE' && heroimgdevice_map && !heroimgdevice_map['MOBILE']) {
            setTimeout(() => {
                setMainimageloaded(true);
            }, 500)

            setTimeout(() => {
                if (device === 'WEB' || device === 'TABLET') {
                    setStartrunsvg(true)
                }
            }, 1000)

            setTimeout(() => {
                if (device === 'MOBILE') {
                    setStartrunsvg(true)
                }
            }, 5000)
        }
    }, [heroimgdevice_map, device])


    // bear
    const btm_ref = useRef(null);
    const scrollToBottom = () => {
        const element = btm_ref.current;
        const targetPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const startPosition = window.pageYOffset;
        const speed = 0.2; // Speed in pixels per millisecond

        let startTime = null;

        const animateScroll = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const increment = timeElapsed * speed;
            const nextPosition = startPosition + increment;

            if ((speed > 0 && nextPosition >= targetPosition) || (speed < 0 && nextPosition <= targetPosition)) {
                window.scrollTo(0, targetPosition);
            } else {
                window.scrollTo(0, nextPosition);
                requestAnimationFrame(animateScroll);
            }
        };

        requestAnimationFrame(animateScroll);
    };
    const btmdiv = <div ref={btm_ref} style={{ width: 0, height: 0 }} />
    // bear

    // advertisement scroll
    useEffect(() => {
        if (videoadgate) {
            setTimeout(() => {
                scrollToBottom()
            }, 3000)
        }
    }, []);

    // const closeportal = () => {
    //     if(frommore){
    //         setShowmore
    //     }
    //     setShowgallery(false)
    //     setShowitinerary(false)
    //     setShowrsvpdom(false)
    //     setShowpromote(false)
    //     setShowshare(false)
    //     setShowcontact(false);
    //     // window.scrollTo(0, 0);
    //     document.getElementById('ilookupt1').style.position = ''
    // }

    const updateBg = () => {

        const device_orientation = wt > ht ? '-' : '|'

        const genWebcss = (imgurl, format) => {

            // ht<750, as img is 1000 by 1000, if the ht of the device is 75%, we will make the img "contain"
            const bgsize = window.innerHeight < 750 ? 'contain' : wt > 1500 ? '45%' : '50%'

            const formatcss = {
                topleft: {
                    right: wt < 1101 ? '80%' : '73%',
                    bottom: wt < 1301 ? '10%' : '20%',
                    backgroundPosition: 'right top',
                    backgroundSize: bgsize
                },
                topright: {
                    left: wt < 1101 ? '80%' : '73%',
                    bottom: wt < 1301 ? '10%' : '20%',
                    backgroundPosition: 'left top',
                    backgroundSize: bgsize
                },
                btmright: {
                    left: wt < 1101 ? '80%' : '73%',
                    top: wt < 1301 ? '10%' : '20%',
                    backgroundPosition: 'left bottom',
                    backgroundSize: bgsize
                },
                btmleft: {
                    right: wt < 1101 ? '80%' : '73%',
                    top: wt < 1301 ? '10%' : '20%',
                    backgroundPosition: 'right bottom',
                    backgroundSize: bgsize
                }
            }

            return {
                ...templateimageloaded ? transition_loaded_css : transition_loading_css,
                backgroundImage: imgurl,
                position: 'fixed',
                width: '100%',
                height: '100%',
                backgroundRepeat: 'no-repeat',
                zIndex: 1,
                ...formatcss[format]
            }
        }

        const genTabletcss = (imgurl, format) => {

            const bgsize = ht < 750 ? 'contain' : '60%' // see genWebcss comment

            const formatcss = {
                topleft: {
                    right: '78%',
                    bottom: '9%',
                    backgroundPosition: 'right top',
                    backgroundSize: bgsize
                },
                topright: {
                    left: '78%',
                    bottom: '9%',
                    backgroundPosition: 'left top',
                    backgroundSize: bgsize
                },
                btmright: {
                    left: '78%',
                    top: '9%',
                    backgroundPosition: 'left bottom',
                    backgroundSize: bgsize
                },
                btmleft: {
                    right: '78%',
                    top: '9%',
                    backgroundPosition: 'right bottom',
                    backgroundSize: bgsize
                },
            }
            return {
                ...templateimageloaded ? transition_loaded_css : transition_loading_css,
                backgroundImage: imgurl,
                position: 'fixed',
                width: '100%',
                height: '100%',
                backgroundRepeat: 'no-repeat',
                zIndex: 1,
                ...formatcss[format]
            }
        }

        const genMobilecss = (imgurl, format) => {
            var sqdim, sqtop, sqbtm

            const { bgformat } = allimages.get(styletype)['t1']
            const nameht = bgformat[styleformationmobile][device]['affectnamepos'] ? 'mobile_ht_top' : 'mobile_ht_center'

            if (ntm === 0) {
                const mobile_title_ht = title_0[nameht]
                sqdim = ((ht - mobile_title_ht) / 2) * 1.65
                sqtop = -ht * 0.3
                sqbtm = `calc( 100% - ( ( 100% - ${mobile_title_ht}px ) / 2 ) )`
            }
            else if (ntm === 1) {
                const mobile_title_ht = title_1[nameht]
                sqdim = ((ht - mobile_title_ht) / 2) * 1.65
                sqtop = -ht * 0.3
                sqbtm = `calc( 100% - ( ( 100% - ${mobile_title_ht}px ) / 2 ) )`
            }
            else {
                const mobile_title_ht = title_2[nameht]
                sqdim = ((ht - mobile_title_ht) / 2) * 1.65
                sqtop = -ht * 0.3
                sqbtm = `calc( 100% - ( ( 100% - ${mobile_title_ht}px ) / 2 ) )`
            }

            const formatcss = {
                topleft: {
                    right: '35%',
                    bottom: sqbtm,
                    backgroundPosition: 'right top',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                topright: {
                    left: '35%',
                    bottom: sqbtm,
                    backgroundPosition: 'left top',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                btmright: {
                    left: '35%',
                    top: sqbtm,
                    backgroundPosition: 'left bottom',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                btmleft: {
                    right: '35%',
                    top: sqbtm,
                    backgroundPosition: 'right bottom',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                btm: {
                    backgroundSize: 'contain',
                    backgroundPosition: 'center bottom',
                    bottom: ht * -0.05,
                    width: '150%',
                    height: ht * 0.5,

                }
            }
            return {
                ...templateimageloaded ? transition_loaded_css : transition_loading_css,
                backgroundImage: imgurl,
                position: 'absolute',
                zIndex: 1,
                backgroundRepeat: 'no-repeat',
                ...formatcss[format]
            }
        }

        const genNearmobilecss = (imgurl, format) => {
            var sqdim, sqtop, sqbtm

            const { bgformat } = allimages.get(styletype)['t1']
            const nameht = bgformat[styleformationmobile][device]['affectnamepos'] ? 'mobile_ht_top' : 'mobile_ht_center'

            if (ntm === 0) {
                const mobile_title_ht = title_0[nameht]
                sqdim = ((ht - mobile_title_ht) / 2) * 1.65
                sqtop = -ht * 0.3
                sqbtm = `calc( 100% - ( ( 100% - ${mobile_title_ht}px ) / 2 ) )`
            }
            else if (ntm === 1) {
                const mobile_title_ht = title_1[nameht]
                sqdim = ((ht - mobile_title_ht) / 2) * 1.65
                sqtop = -ht * 0.3
                sqbtm = `calc( 100% - ( ( 100% - ${mobile_title_ht}px ) / 2 ) )`
            }
            else {
                const mobile_title_ht = title_2[nameht]
                sqdim = ((ht - mobile_title_ht) / 2) * 1.65
                sqtop = -ht * 0.3
                sqbtm = `calc( 100% - ( ( 100% - ${mobile_title_ht}px ) / 2 ) )`
            }

            const formatcss = {
                topleft: {
                    right: '45%',
                    bottom: sqbtm,
                    backgroundPosition: 'right top',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                topright: {
                    left: '45%',
                    bottom: sqbtm,
                    backgroundPosition: 'left top',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                btmright: {
                    left: '45%',
                    top: sqbtm,
                    backgroundPosition: 'left bottom',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                btmleft: {
                    right: '45%',
                    top: sqbtm,
                    backgroundPosition: 'right bottom',
                    backgroundSize: 'contain',
                    width: sqdim,
                    height: sqdim,
                },
                btm: {
                    backgroundSize: 'contain',
                    backgroundPosition: 'center bottom',
                    bottom: ht * -0.05,
                    width: '150%',
                    height: ht * 0.5,

                }
            }
            return {
                ...templateimageloaded ? transition_loaded_css : transition_loading_css,
                backgroundImage: imgurl,
                position: 'absolute',
                zIndex: 1,
                backgroundRepeat: 'no-repeat',
                ...formatcss[format]
            }
        }

        if (styletype.length > 0) {
            // whale
            const bgformatdevice = { "WEB": "WEB_TABLET", TABLET: "WEB_TABLET", MOBILE: "MOBILE" }[device] // tablet and web share the same key
            const gencss_based_on_device = { 'WEB': genWebcss, 'TABLET': genTabletcss, 'MOBILE': wt < 555 ? genMobilecss : genNearmobilecss }[device]

            const { background, bgformat } = allimages.get(styletype)['t1']

            let currdevice_styleformation = device === 'MOBILE' ? styleformationmobile : styleformation

            let curr_bgformat = bgformat[parseInt(currdevice_styleformation)]

            let currdevice_styleorientation = device === 'MOBILE' ? styleorientationmobile : styleorientation

            let curr_orientation = curr_bgformat[{ 'WEB': 'orientation_allow_list', 'TABLET': 'orientation_allow_list', 'MOBILE': 'orientation_allow_listmobile' }[device]][parseInt(currdevice_styleorientation)]

            let firstimg_orientation = curr_orientation['img1']
            let secondimg_orientation = curr_orientation['img2']

            let firstimg_format = curr_bgformat[bgformatdevice]['bg1']
            let secondimg_format = curr_bgformat[bgformatdevice]['bg2']

            let image1_url = firstimg_format ? 'url(' + background[firstimg_format]['url'][firstimg_orientation] + ')' : null
            let image2_url = secondimg_format ? 'url(' + background[secondimg_format]['url'][secondimg_orientation] + ')' : null

            let image1_css = gencss_based_on_device(image1_url, firstimg_format)
            let image2_css = gencss_based_on_device(image2_url, secondimg_format)

            var id_bgstylea_map = {}
            id_bgstylea_map[styletype] = [
                <div
                    id="topbg"
                    type="IMG"
                    key={'ilookup_left_' + device_orientation + '_' + device}
                    className={device}
                    style={image1_css}
                />,
                <div
                    id="btmbg"
                    type="IMG"
                    key={'ilookup_right_' + device_orientation + '_' + device}
                    className={device}
                    style={image2_css}
                />
            ]

            setId_bgstylea_map(id_bgstylea_map)
            setId_bgstyleb_map({})

            if (videoadgate) {
                // document.body.style.overflow = 'hidden'
                document.body.style.overflow = 'auto';
                const imgsarr = ['Amaryllis_Purpurea', 'Blanket_Flower', 'Crimson_Damask', 'Helenium', 'Mexican_Poppy', 'Myosotis_Alpestris', 'White_Odontoglossum']

                let q = 0
                function runthis(q) {
                    setTimeout(() => {

                        const { background, bgformat } = allimages.get(imgsarr[q])['t1']

                        let currdevice_styleformation = device === 'MOBILE' ? styleformationmobile : styleformation

                        let curr_bgformat = bgformat[parseInt(currdevice_styleformation)]

                        let currdevice_styleorientation = device === 'MOBILE' ? styleorientationmobile : styleorientation

                        let curr_orientation = curr_bgformat['orientation_allow_list'][parseInt(currdevice_styleorientation)]

                        let firstimg_orientation = curr_orientation['img1']
                        let secondimg_orientation = curr_orientation['img2']

                        let firstimg_format = curr_bgformat[bgformatdevice]['bg1']
                        let secondimg_format = curr_bgformat[bgformatdevice]['bg2']

                        let image1_url = firstimg_format ? 'url(' + background[firstimg_format]['url'][firstimg_orientation] + ')' : null
                        let image2_url = secondimg_format ? 'url(' + background[secondimg_format]['url'][secondimg_orientation] + ')' : null

                        let image1_css = gencss_based_on_device(image1_url, firstimg_format)
                        let image2_css = gencss_based_on_device(image2_url, secondimg_format)

                        var id_bgstylea_map = {}
                        id_bgstylea_map[styletype] = [
                            <div key={'ilookup_left_' + device_orientation + '_' + device} id="topbg" className={device} type="IMG" style={image1_css} />,
                            <div key={'ilookup_right_' + device_orientation + '_' + device} id="btmbg" className={device} type="IMG" style={image2_css} />
                        ]

                        setStylesep(`https://asset.weavebliss.com/assets/floral/${imgsarr[q]}/banner/banner.png`)
                        setId_bgstylea_map(id_bgstylea_map)
                        setId_bgstyleb_map({})

                        q++;
                        if (q < imgsarr.length) { runthis(q) }
                        else {
                            q = 0;
                            window.scrollTo(0, 0)
                        }
                    }, 3000)
                }
                runthis(q)
            }

        }

    }

    const mobilepreload_dom = <Textfit
        onReady={() => { setTimeout(() => { setMobilepreloaded(true) }, 1000) }}
        style={{ fontFamily: secff, color: fc, width: 'calc( 100vw - 20px )', height: 'calc( 100% - 20px )', top: 10, backgroundColor: '#ffffffcc', position: 'absolute', placeContent: 'center', textAlign: 'center', alignItems: 'center', display: 'flex', zIndex: 1, padding: 40, flexDirection: 'column', opacity: 0 }}>
        <div style={{ opacity: 0, height: '50%', display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column', placeContent: 'flex-end' }}>
            <div style={{ whiteSpace: 'nowrap' }}>{`${name1} `}</div>
            <div style={{ whiteSpace: 'nowrap' }}>{`& ${name2}`}</div>
        </div>
        <div style={{ opacity: 0, height: '50%', display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column', placeContent: 'flex-end' }}>
            <div style={{ whiteSpace: 'nowrap' }}>{`are getting `}</div>
            <div style={{ whiteSpace: 'nowrap' }}>{`married`}</div>
        </div>
    </Textfit>

    // we fade in animation of " Bob & Alice are getting married. "
    const mobiletitleanimated_dom = (ht) => <>
        {/* <div style={{ fontFamily: secff, color: fc, backgroundColor: templatecolor, opacity: 0.7, width: '100vw', height: '100%', position: 'absolute', placeContent: 'center', textAlign: 'center', alignItems: 'center', display: 'flex', zIndex: 2, padding: 40, flexDirection: 'column' }} /> */}
        <div style={{ fontFamily: secff, color: fc, backgroundColor: 'transparent', width: '100vw', height: ht, position: 'absolute', placeContent: 'center', textAlign: 'center', alignItems: 'center', display: 'flex', zIndex: 2, padding: 40, flexDirection: 'column' }} />

        {/* <Textfit
            className="ilookup_mobilefadeinandout"
            onReady={() => { setTimeout(() => { setShowtitle(true) }, 7000);}}
            style={{ fontFamily: secff, color: fc, width: 'calc( 100vw - 20px )', height: 'calc( 100% - 20px )', top: 10, backgroundColor: 'transparent', position: 'absolute', placeContent: 'center', textAlign: 'center', alignItems: 'center', display: 'flex', zIndex: 2, padding: 40, flexDirection: 'column', borderRadius: 10 }}>
            <div style={{ height: '50%', display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column', placeContent: 'flex-end' }}>
                <div style={{ whiteSpace: 'nowrap' }}>{`${name1} `}</div>
                <div style={{ whiteSpace: 'nowrap' }}>{`& ${name2}`}</div>
            </div>
            <div style={{ height: '50%', display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column', placeContent: 'flex-end' }}>
                <div style={{ whiteSpace: 'nowrap' }}>{`are getting `}</div>
                <div style={{ whiteSpace: 'nowrap' }}>{`married`}</div>
            </div>
        </Textfit> */}

        <Textfit
            className="ilookup_mobilefadeinandout"
            onReady={() => { setTimeout(() => { setShowtitle(true) }, nameanimationdata['duration']); }}
            style={{ animationDuration: `${(nameanimationdata['duration'] / 1000) + 's'}`, WebkitAnimationDuration: `${(nameanimationdata['duration'] / 1000) + 's'}`, fontFamily: secff, color: fc, width: 'calc( 100vw - 10px )', height: `calc( ${ht}px - 10px )`, top: 10, backgroundColor: 'transparent', position: 'absolute', placeContent: 'center', textAlign: 'center', alignItems: 'center', display: 'flex', zIndex: 2, padding: 20, flexDirection: 'column' }}>
            {/* <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column', placeContent: 'flex-end' }}>
                <div style={{ whiteSpace: 'nowrap' }}>{`${name1} `}</div>
                <div style={{ whiteSpace: 'nowrap' }}>{`& ${name2}`}</div>
            </div> */}
            <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column', placeContent: 'flex-end' }}>
                {/* <div style={{ whiteSpace: 'nowrap' }}>{`are getting married. `}</div>
                <div style={{ whiteSpace: 'nowrap' }}>{`Join us as `}</div>
                <div style={{ whiteSpace: 'nowrap' }}>{`we celebrate our wedding.`}</div> */}
                {/* <div style={{ whiteSpace: 'nowrap' }}>{`Join us in witnessing`}</div>
                <div style={{ whiteSpace: 'nowrap' }}>{`the union of`}</div> */}
                <div style={{ whiteSpace: 'pre' }}>{nameanimationdata['txt']}</div>
            </div>

        </Textfit>
    </>

    // this will allow the text to be viewable in full height. Re-adjustment screen size dom for T1titles_dom (show_title = true)
    const titleheightreadjust_dom = (ht) => {
        return <Textfit
            key="titleheightreadjust_dom"
            onReady={() => { setTimeout(() => { setShowtitle(true) }, 300) }}
            style={{ fontFamily: secff, color: fc, width: '100%', height: ht, placeContent: 'center', textAlign: 'center', alignItems: 'center', display: 'flex', zIndex: 1, padding: 40, flexDirection: 'column', borderRadius: 10, opacity: 0 }}>
        </Textfit>
    }

    const T1titles_dom = () => {
        if (device === 'MOBILE') {

            // based on the name1 length and name2 length, decide the margin
            const { bgformat } = allimages.get(styletype)['t1']
            const state = bgformat[styleformationmobile][device]['affectnamepos']
            const localht = state ? ht * 0.60 : ht // flower will overlap with btm of name
            const titlehtcmd = state ? 'mobile_ht_top' : 'mobile_ht_center'
            const mobile_title_ht = [title_0[titlehtcmd], title_1[titlehtcmd], title_2[titlehtcmd]][ntm]

            let { margin_top, margin_btm, margin_left, margin_right } = (menutype !== 'none')
                ? [title_0, title_1, title_2][ntm][device][menutype]
                : { 'margin_top': 0, 'margin_btm': 0, 'margin_left': 0, 'margin_right': 0 }

            let margins = {
                marginTop: margin_top, marginBottom: margin_btm,
                marginLeft: margin_left, marginRight: margin_right
            }

            return !mobilepreloaded
                ? mobilepreload_dom
                : showtitle
                    ? [
                        <div
                            className='ilookup_mobilemaintxt'
                            style={{ height: localht, margin: title_1.mobile_margin, ...margins, }}>
                            <Textfit forceSingleModeWidth={true} style={{ fontFamily: secff, color: fc, width: '100%', height: title_0[state ? 'mobile_ht_top' : 'mobile_ht_center'], position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ height: mobile_title_ht * title_0.title_layer1, textAlign: 'center', placeContent: 'center', display: 'flex', alignItems: 'flex-end', whiteSpace: 'pre', }}>{name1}</div>
                                <Textfit style={{ height: mobile_title_ht * title_0.title_layer2, textAlign: 'center', placeContent: 'center', display: 'flex', alignItems: 'center', whiteSpace: 'pre', }} >{'&'}</Textfit>
                                <div style={{ height: mobile_title_ht * title_0.title_layer3, textAlign: 'center', placeContent: 'center', display: 'flex', alignItems: 'flex-start', whiteSpace: 'pre', }}>{name2}</div>
                            </Textfit>
                        </div>,
                        <div
                            className='ilookup_mobilemaintxt'
                            style={{ height: localht, margin: title_2.mobile_margin, ...margins, }}>
                            <Textfit forceSingleModeWidth={true} style={{ height: mobile_title_ht, width: '100%', fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: 'normal', alignItems: 'center' }}>
                                <div style={{ height: mobile_title_ht * title_1.title_layer1, width: '100%', placeContent: 'center', display: 'flex', alignItems: 'flex-end', whiteSpace: 'pre' }}>{name1}</div>
                                <div style={{ height: mobile_title_ht * title_1.title_layer2, width: '100%', placeContent: 'center', display: 'flex', alignItems: 'flex-start', whiteSpace: 'pre', }}>{"& " + name2}</div>
                            </Textfit>
                        </div>,
                        <div
                            className='ilookup_mobilemaintxt'
                            style={{ height: localht, margin: title_2.mobile_margin, ...margins, }}>
                            <Textfit style={{ width: '100%', height: mobile_title_ht, fontFamily: secff, color: fc, placeContent: 'center', display: 'flex', alignItems: 'center', placeSelf: 'center', whiteSpace: 'pre', }}>
                                {name1 + ' & ' + name2}
                            </Textfit>
                        </div>
                    ][ntm] // name title for mobile
                    : [
                        mobiletitleanimated_dom(localht),
                        titleheightreadjust_dom(localht)
                    ][nam] // name animation for mobile
        }
        else if (device === 'TABLET') {
            let { margin_top, margin_btm, margin_left, margin_right } = (menutype !== 'none') ? [title_0, title_1, title_2][ntt][device][menutype] : { 'margin_top': 0, 'margin_btm': 0, 'margin_left': 0, 'margin_right': 0 }

            return showtitle
                ? [
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_0.tablet_ht, width: WEB_TABLET_WT * 0.65, display: 'flex', flexDirection: 'column', placeContent: 'center', fontFamily: secff, color: fc, fontWeight: 'normal', position: 'relative', lineHeight: 'normal',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        <div style={{ height: title_0.tablet_ht * title_0.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <Textfit style={{ height: title_0.tablet_ht * title_0.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'baseline' }}>
                            {'&'}
                        </Textfit>
                        <div style={{ height: title_0.tablet_ht * title_0.title_layer3, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_1.tablet_ht, width: WEB_TABLET_WT * 0.65, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: 'normal', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        <div style={{ height: title_1.tablet_ht * title_1.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <div style={{ height: title_1.tablet_ht * title_1.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{"& " + name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_2.tablet_ht, width: WEB_TABLET_WT * 0.65, fontFamily: secff, color: fc, placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        {name1 + ' & ' + name2}
                    </Textfit>
                ][ntt]
                : nat === 1
                    ? null // might add animatedtablet_title
                    : titleheightreadjust_dom([title_0.tablet_ht, title_1.tablet_ht, title_2.tablet_ht][ntw])
        }
        else if (device === 'WEB') {
            const stubmargin = 40
            let { margin_top, margin_btm, margin_left, margin_right } = (menutype !== 'none') ? [title_0, title_1, title_2][ntw][device][menutype] : { 'margin_top': 0, 'margin_btm': 0, 'margin_left': 0, 'margin_right': 0 }
            return showtitle
                ? [
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_0.web_ht, width: WEB_TABLET_WT * 0.95, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        <div style={{ height: title_0.web_ht * title_0.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <Textfit style={{ height: title_0.web_ht * title_0.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'baseline' }}>{'&'}</Textfit>
                        <div style={{ height: title_0.web_ht * title_0.title_layer3, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_1.web_ht, width: WEB_TABLET_WT * 0.95, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}
                    >
                        <div style={{ height: title_1.web_ht * title_1.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <div style={{ height: title_1.web_ht * title_1.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{"& " + name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_2.web_ht, width: WEB_TABLET_WT * 0.95, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center', whiteSpace: 'pre',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}
                    >
                        {name1 + ' & ' + name2}
                    </Textfit>
                ][ntw]
                : naw === 1
                    ? null // might add animatedtablet_title
                    : titleheightreadjust_dom([title_0.web_ht + stubmargin * 2, title_1.web_ht + stubmargin * 2, title_2.web_ht][ntw])
        }
        else return <div></div>
    }

    const T2titles_dom = () => {
        if (device === 'MOBILE') {

            // based on the name1 length and name2 length, decide the margin
            const { bgformat } = allimages.get(styletype)['t1']
            const state = bgformat[styleformationmobile][device]['affectnamepos']
            // const localht = state ? ht * 0.60 : ht // flower will overlap with btm of name
            const localht = ht
            const titlehtcmd = state ? 'mobile_ht_top' : 'mobile_ht_center'
            const mobile_title_ht = [title_0[titlehtcmd], title_1[titlehtcmd], title_2[titlehtcmd]][ntm]

            let { margin_top, margin_btm, margin_left, margin_right } = (menutype !== 'none')
                ? [title_0, title_1, title_2][ntm][device][menutype]
                : { 'margin_top': 0, 'margin_btm': 0, 'margin_left': 0, 'margin_right': 0 }


            return !mobilepreloaded
                ? mobilepreload_dom
                : showtitle
                    ? [
                        <div
                            className='ilookup_mobilemaintxt'
                            style={{
                                width: '100%', height: '100%', margin: title_1.mobile_margin,
                                display: 'flex', flexDirection: 'column', placeContent: 'center', alignItems: 'center',
                                marginTop: margin_top, marginBottom: margin_btm,
                                marginLeft: margin_left, marginRight: margin_right,
                            }}>
                            <Textfit forceSingleModeWidth={true} style={{ fontFamily: secff, color: fc, width: '90%', height: title_0[state ? 'mobile_ht_top' : 'mobile_ht_center'], position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ height: mobile_title_ht * title_0.title_layer1, textAlign: 'center', placeContent: 'center', display: 'flex', alignItems: 'flex-end', whiteSpace: 'pre', }}>{name1}</div>
                                <Textfit style={{ height: mobile_title_ht * title_0.title_layer2, textAlign: 'center', placeContent: 'center', display: 'flex', alignItems: 'center', whiteSpace: 'pre', }} >{'&'}</Textfit>
                                <div style={{ height: mobile_title_ht * title_0.title_layer3, textAlign: 'center', placeContent: 'center', display: 'flex', alignItems: 'flex-start', whiteSpace: 'pre', }}>{name2}</div>
                            </Textfit>
                        </div>,
                        <div
                            className='ilookup_mobilemaintxt'
                            style={{
                                width: '100%', height: '100%', margin: title_2.mobile_margin,
                                display: 'flex', flexDirection: 'column', placeContent: 'center', alignItems: 'center',
                                marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right,
                            }}
                        >
                            <Textfit forceSingleModeWidth={true} style={{ height: mobile_title_ht, width: '90%', fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: 'normal', alignItems: 'center' }}>
                                <div style={{ height: mobile_title_ht * title_1.title_layer1, width: '100%', placeContent: 'center', display: 'flex', alignItems: 'flex-end', whiteSpace: 'pre' }}>{name1}</div>
                                <div style={{ height: mobile_title_ht * title_1.title_layer2, width: '100%', placeContent: 'center', display: 'flex', alignItems: 'flex-start', whiteSpace: 'pre', }}>{"& " + name2}</div>
                            </Textfit>
                        </div>,
                        <div
                            className='ilookup_mobilemaintxt'
                            style={{
                                width: '100%', height: '100%', margin: title_2.mobile_margin,
                                display: 'flex', flexDirection: 'column', placeContent: 'center', alignItems: 'center',
                                marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right,
                            }}>
                            <Textfit style={{ width: '90%', height: mobile_title_ht, fontFamily: secff, color: fc, placeContent: 'center', display: 'flex', alignItems: 'center', placeSelf: 'center', whiteSpace: 'pre', }}>
                                {name1 + ' & ' + name2}
                            </Textfit>
                        </div>
                    ][ntm] // name title for mobile
                    : [
                        mobiletitleanimated_dom(localht),
                        titleheightreadjust_dom(localht)
                    ][nam] // name animation for mobile
        }
        else if (device === 'TABLET') {
            let { margin_top, margin_btm, margin_left, margin_right } = (menutype !== 'none') ? [title_0, title_1, title_2][ntt][device][menutype] : { 'margin_top': 0, 'margin_btm': 0, 'margin_left': 0, 'margin_right': 0 }

            return showtitle
                ? [
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_0.tablet_ht, width: WEB_TABLET_WT * 0.65, display: 'flex', flexDirection: 'column', placeContent: 'center', fontFamily: secff, color: fc, fontWeight: 'normal', position: 'relative', lineHeight: 'normal',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        <div style={{ height: title_0.tablet_ht * title_0.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <Textfit style={{ height: title_0.tablet_ht * title_0.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'baseline' }}>
                            {'&'}
                        </Textfit>
                        <div style={{ height: title_0.tablet_ht * title_0.title_layer3, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_1.tablet_ht, width: WEB_TABLET_WT * 0.65, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: 'normal', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        <div style={{ height: title_1.tablet_ht * title_1.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <div style={{ height: title_1.tablet_ht * title_1.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{"& " + name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_2.tablet_ht, width: WEB_TABLET_WT * 0.65, fontFamily: secff, color: fc, placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        {name1 + ' & ' + name2}
                    </Textfit>
                ][ntt]
                : nat === 1
                    ? null // might add animatedtablet_title
                    : titleheightreadjust_dom([title_0.tablet_ht, title_1.tablet_ht, title_2.tablet_ht][ntw])
        }
        else if (device === 'WEB') {
            const stubmargin = 40
            let { margin_top, margin_btm, margin_left, margin_right } = (menutype !== 'none') ? [title_0, title_1, title_2][ntw][device][menutype] : { 'margin_top': 0, 'margin_btm': 0, 'margin_left': 0, 'margin_right': 0 }
            return showtitle
                ? [
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_0.web_ht, width: WEB_TABLET_WT * 0.95, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}>
                        <div style={{ height: title_0.web_ht * title_0.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <Textfit style={{ height: title_0.web_ht * title_0.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'baseline' }}>{'&'}</Textfit>
                        <div style={{ height: title_0.web_ht * title_0.title_layer3, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_1.web_ht, width: WEB_TABLET_WT * 0.95, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}
                    >
                        <div style={{ height: title_1.web_ht * title_1.title_layer1, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-end' }}>{name1}</div>
                        <div style={{ height: title_1.web_ht * title_1.title_layer2, width: '100%', placeContent: 'center', whiteSpace: 'pre', display: 'flex', alignItems: 'flex-start' }}>{"& " + name2}</div>
                    </Textfit>,
                    <Textfit
                        className="ilookup_webfadein"
                        style={{
                            height: title_2.web_ht, width: WEB_TABLET_WT * 0.95, fontFamily: secff, color: fc, display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative', lineHeight: 'normal', alignItems: 'center', whiteSpace: 'pre',
                            marginTop: margin_top, marginBottom: margin_btm, marginLeft: margin_left, marginRight: margin_right
                        }}
                    >
                        {name1 + ' & ' + name2}
                    </Textfit>
                ][ntw]
                : naw === 1
                    ? null // might add animatedtablet_title
                    : titleheightreadjust_dom([title_0.web_ht + stubmargin * 2, title_1.web_ht + stubmargin * 2, title_2.web_ht][ntw])
        }
        else return <div></div>
    }

    const pagescrolldown_dom = showtitle && pagedownbtnappear
        ? <button
            ref={pagescrolldown_ref}
            className="ilookup_scrolldown"
            onClick={() => {
                window.scrollTo({ behavior: 'smooth', top: startimg_ref.current.offsetTop - 60 })
                setStartrunsvg(true)
            }}
            // style={{ display: 'flex', backgroundColor: 'white', opacity: window.pageYOffset > 70 ? 0 : 1, zIndex: 2, bottom: 42, pointerEvents: 'auto', position: 'fixed', borderRadius: '50%', borderStyle: 'none', justifyContent: 'center', alignItems: 'center', height: window.pageYOffset > 70 ? 0 : 50, width: window.pageYOffset > 70 ? 0 : 50, outline: 'none', cursor: 'pointer', left: 'calc( 50% - 25px )', marginBottom: menutype === 'btmnavbar' ? 75 : 0, }}>
            style={{ display: 'flex', backgroundColor: templatecolor, fill: fc, opacity: window.pageYOffset > 70 ? 0 : 1, zIndex: 2, bottom: 42, pointerEvents: 'auto', position: 'fixed', borderRadius: '50%', borderStyle: 'none', justifyContent: 'center', alignItems: 'center', height: window.pageYOffset > 70 ? 0 : 50, width: window.pageYOffset > 70 ? 0 : 50, outline: 'none', cursor: 'pointer', left: 'calc( 50% - 25px )', marginBottom: menutype === 'btmnavbar' ? 75 : 0, }}>
            <svg width="24" height="24" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21623"><path d="M585.246075 875.340272l408.227201-447.966132c57.440818-63.040395 12.824837-164.374669-72.613865-164.374669H104.224378c-85.25807 0-130.054683 101.334274-72.613865 164.374669l408.407832 447.7855c39.016405 42.809667 106.211325 42.809667 145.22773 0.180632z" p-id="21624"></path></svg>
        </button>
        : null

    // const wedosvg = <svg style={{ color: '#ffffff',  position:'absolute' }} width="100%" height="100%" viewBox="0 0 7274 1532" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16 1183.61C31 1123.11 94.2 1001.41 227 998.607C359.8 995.807 606.333 1019.11 713 1031.11C979 1080.11 814.5 1041.61 1132 1098.61C1424.34 1151.09 1520 978.107 1531.5 1015.61C1543 1053.11 1507.5 1565.61 1609.5 1503.61C1711.5 1441.61 1817.5 1062.61 1803.5 1022.61C1789.5 982.607 1750.5 1611.61 1896.5 1503.61C2042.5 1395.61 2086.45 1122.01 2099 1044.11C2116 938.607 2075.5 794.607 1970 799.107C1864.5 803.607 1970.01 1049.49 2090 1087.61C2215.5 1127.47 2265.5 1127.48 2400 1038.11C2595 908.535 2545.5 792.107 2477 792.107C2428.49 792.107 2286.5 853.607 2298 1100.61C2309.5 1347.61 2618 1323.61 2876 1271.61C3152.99 1215.78 3533 990.711 3533 990.711C3533 990.711 3889.5 753.107 3948.5 595.607C4007.5 438.107 3947 262.607 3818 259.107C3689 255.607 3581.5 452.107 3581.5 461.107C3581.5 470.107 3528 237.607 3341.5 259.107C3155 280.607 3114 549.607 3250 717.607C3386 885.607 3675.48 1146.82 4017.5 1255.11C4306.5 1346.61 4651 1224.11 4747.5 1106.11M4747.5 1106.11C4743.56 1112.15 4739.72 1119.36 4735.99 1127.55C4617.62 1387.69 4812.04 1435.52 4939.17 1179.56C5182.82 688.985 5437.3 69.1619 5299 18.607C5061 -68.393 4926 1447.11 5079.5 1468.11C5188.65 1483.04 5328.39 1157.43 5435.09 969.107M4747.5 1106.11C4836.8 969.107 4942.59 978.907 5018.19 988.107M5536.5 843.107C5689 875.607 5758 1251.61 5597 1346.61C5436 1441.61 5383.7 1051.11 5435.09 969.107M5536.5 843.107C5498 841.922 5478.44 892.591 5435.09 969.107M5536.5 843.107C5682 899.607 5748.27 1017.06 5891.5 1040.61C6037.5 1064.61 6112 1064.11 6333.5 969.107C6555 874.107 6788.22 784.107 6943.5 784.107C6983 784.107 7046 778.607 7178 839.607C7283.6 888.407 7262.67 963.94 7239 995.607" stroke="currentColor" stroke-width="30" strokeLinecap="round" /> </svg>

    const mainimg_dom = (wt, z = 999, br) => {

        if (device === 'MOBILE' && heroimgdevice_map && !heroimgdevice_map['MOBILE']) {
            return <div
                ref={startimg_ref}
                id={"ilookup_imgidcontainer_portrait"}
                style={{
                    width: wt,
                    zIndex: z,
                    height: 0,
                    maxHeight: 0
                }}
            >
                <div ref={mainimg_ref}></div>
            </div>
        }

        // startimg_ref , mainimg_ref

        const onload = () => {
            // window.scrollTo(0, lastcapturePosition);

            setTimeout(() => {
                if (!mainimageloaded) { setMainimageloaded(true); }
            }, 500)

            setTimeout(() => {
                if (device === 'WEB' || device === 'TABLET') {
                    setStartrunsvg(true)
                }
            }, 1000)

            setTimeout(() => {
                if (device === 'MOBILE') {
                    setStartrunsvg(true)
                }
            }, 5000)
        }

        if (templatetype === 1) {
            // svgoverlay_map, imgcss_map
            // const imglink = (images && images[0]) ? images[0] : null

            return (
                <div
                    ref={startimg_ref}
                    id={"ilookup_imgidcontainer_portrait"}
                    style={{
                        width: wt,
                        zIndex: z
                    }}
                >

                    {svgoverlay_map && svgoverlay_map['svgitem'] !== EMPTY_SVG
                        ? <div style={{ height: 'calc( 100% - 70px )', width: '100%', position: 'absolute', display: 'flex', margin: '30px 0px', zIndex: 1 }}>
                            <Runsvg startrunsvg={startrunsvg} svgoverlay_map={svgoverlay_map} svgstate={svgstate} device={device} />
                        </div>
                        : null}

                    {(svgoverlay_map && svgoverlay_map['replay'] && svgoverlay_map['mode'] === INFINITELOOP_MODE && svgoverlay_map['svgitem'] !== EMPTY_SVG)
                        ? <button
                            onClick={() => {
                                setSvgstate(svgstate === 'PAUSE' ? 'PLAYING' : 'PAUSE')
                            }}
                            style={{ color: svgoverlay_map['color'], border: 'none', bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', placeContent: 'center', padding: 0, margin: 10, backgroundColor: 'transparent', zIndex: 1 }}
                        >
                            {{
                                'PAUSE': iconwrapper(PLAY_ICON, { width: 25, height: 25, display: 'flex' }),
                                'PLAYING': iconwrapper(PAUSE_ICON, { width: 25, height: 25, display: 'flex' })
                            }[svgstate]}
                        </button>
                        : null}

                    {{
                        'single': device !== 'MOBILE'
                            ? <T1Single_WEB
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                device={device}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                                transition_css_mainimg={mainimageloaded ? { transitionDuration: '640ms', opacity: 1 } : { opacity: 0 }}
                                portrait_or_landscape={'portrait'}
                            />
                            : <T1Single_MOBILE
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                                transition_css_mainimg={mainimageloaded ? { transitionDuration: '640ms', opacity: 1 } : { opacity: 0 }}
                                portrait_or_landscape={'portrait'}
                            />,
                        'marquee': device !== 'MOBILE'
                            ? <T1Marquee_WEB
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                device={device}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                                portrait_or_landscape={'portrait'}
                            />
                            : <T1_AND_T2_Marquee_MOBILE
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                device={device}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                                portrait_or_landscape={'portrait'}
                            />,

                        'slideshow': device !== 'MOBILE'
                            ? <T1Slideshow_WEB
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                ht={ht}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                            />
                            : <T1Slideshow_MOBILE
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                device={device}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                                portrait_or_landscape={'landscape'}
                            />
                    }[heroimglayout]}

                </div>
            )
        }
        else if (templatetype === 2) {
            // svgoverlay_map, imgcss_map

            return (
                <div
                    ref={startimg_ref}
                    style={{
                        display: 'flex',
                        position: 'relative',
                        width: wt,
                        zIndex: z,
                        // aspectRatio: { 'WEB': '12/7', 'TABLET': '12/7', 'MOBILE': '12/7' }[device],
                        overflowX: 'hidden'
                    }}
                >
                    {svgoverlay_map && svgoverlay_map['svgitem'] !== EMPTY_SVG
                        ? <div style={{ height: 'calc( 100% - 70px )', width: '100%', position: 'absolute', display: 'flex', margin: '30px 0px', zIndex: 1 }}>
                            <Runsvg
                                startrunsvg={startrunsvg}
                                svgoverlay_map={svgoverlay_map}
                                svgstate={svgstate}
                                device={device}
                            />
                        </div>
                        : null}

                    {(svgoverlay_map && svgoverlay_map['replay'] && svgoverlay_map['mode'] === INFINITELOOP_MODE && svgoverlay_map['svgitem'] !== EMPTY_SVG)
                        ? <button
                            onClick={() => {
                                setSvgstate(svgstate === 'PAUSE' ? 'PLAYING' : 'PAUSE')
                            }}
                            style={{ color: svgoverlay_map['color'], border: 'none', bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', placeContent: 'center', padding: 0, margin: 10, backgroundColor: 'transparent', zIndex: 1 }}
                        >
                            {{
                                'PAUSE': iconwrapper(PLAY_ICON, { width: 25, height: 25, display: 'flex' }),
                                'PLAYING': iconwrapper(PAUSE_ICON, { width: 25, height: 25, display: 'flex' })
                            }[svgstate]}
                        </button>
                        : null}

                    {{
                        'single': <T2Single_WEB_and_MOBILE
                            heroimgs={heroimgs}
                            br={br}
                            wt={wt}
                            device={device}
                            onload={onload}
                            mainimg_ref={mainimg_ref}
                            transition_css_mainimg={mainimageloaded ? { transitionDuration: '640ms', opacity: 1 } : { opacity: 0 }}
                            portrait_or_landscape={'landscape'}
                        />,
                        'marquee': device !== 'MOBILE'
                            ? <T2Marquee_WEB
                                heroimgs={heroimgs}
                                ht={ht}
                                wt={wt}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                            />
                            : <T1_AND_T2_Marquee_MOBILE
                                heroimgs={heroimgs}
                                wt={wt}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                            />,
                        'slideshow': device !== 'MOBILE'
                            ? <T2Slideshow_WEB
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                ht={ht}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                            />
                            : <T2Slideshow_MOBILE
                                heroimgs={heroimgs}
                                br={br}
                                wt={wt}
                                device={device}
                                onload={onload}
                                mainimg_ref={mainimg_ref}
                                portrait_or_landscape={'landscape'}
                            />

                    }[heroimglayout]}
                </div>
            )
        }
        else {
            return null
        }

    }

    const maintext_dom = (wt, fs) => {
        return maintext ? <div key={'maintext'} style={{ fontSize: fs, color: fc, lineheight: FS_LH_MAP[fs], width: wt, padding: universal_padding, display: 'flex', flexDirection: 'column', alignSelf: 'center', alignContent: 'center', textAlign: 'center', justifyContent: 'center', borderRadius: 20, ...css_map['maintext'] }}>{maintext}</div> : null// boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none',
    }

    const subtext_dom = (wt, fs) => {
        return subtext && subtext.length > 0 ? <div key={'subtext'} style={{ fontSize: fs, color: fc, lineHeight: FS_LH_MAP[fs], width: wt, padding: universal_padding, display: 'flex', flexDirection: 'column', alignSelf: 'center', alignContent: 'center', textAlign: 'center', justifyContent: 'center', borderRadius: 20, ...css_map['subtext'] }}>{subtext}</div> : null// boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none',
    }

    const location_dom = (wt, z) => {
        const fs = device === 'MOBILE' ? 26 : 33
        const pad = device === 'MOBILE' ? '20px 5px' : universal_padding
        return location
            ? <div
                key={'location'}
                id='ilookup_loc'
                style={{ width: wt, fontSize: fs, color: fc, fontFamily: locationff, padding: pad, zIndex: z, textAlign: 'center', display: 'flex', flexDirection: 'row', placeSelf: 'center', placeContent: 'center', cursor: 'pointer', whiteSpace: 'pre' }}
            // onClick={() => {
            //     if (lat.length > 0 && long.length > 0) {
            //         window.open("https://www.google.com/maps/search/?api=1&query=" + lat + "," + long, "_blank")
            //     }
            // }}
            >
                {location}
                {/* {lat > 0 && long > 0 ? <div style={{ padding: '0px 4px' }}>{GPS_ICON}</div> : null} */}
            </div>
            : null
    }

    const datetime_dom = <Invdate
        key={'ilookupinvdate'}
        countdown={countdown}
        date_e={date_e}
        date_w={date_w}
        itype={itype}
        dt_type={dt_type}
        time={time}
        fc={fc}
        device={device}
        from={'Invitationlookup_' + templatetype}
        datetimeff={datetimeff}
    />

    const party_dom = (partywt, fs) => {

        const title_fs = device === 'MOBILE' ? 24 : 28


        // party partyproperties
        // party's item : id, email, info, name, number, photo, title 
        // partyproperties : format, imageshape

        const partyportalclick = (index) => {
            setSinglepartymemberdata(JSON.parse(JSON.stringify(party[index])))
            opensomething('Party')
        }

        if (device === 'MOBILE') {
            return party && party.length > 0 && displayonoffmap && displayonoffmap['party']
                ? [
                    <div key="party_key" style={{ width: partywt, color: fc, display: 'flex', flexDirection: 'column', alignSelf: 'center', padding: '40px 0px' }}>
                        {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
                        <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                            <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                                {displaytxtmap['party']}
                            </div>
                        </div>
                        {party.map((item, index) => {
                            const firstitem = party[index]
                            const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                            const imgdim = 150

                            return <div key={'party' + index} style={{ width: '100%', display: 'flex', flexDirection: 'row', marginBottom: 30, placeContent: 'center', padding: '0px 20px', }}>
                                <div id={firstitem.id} style={{ width: '100%', minHeight: 300, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                    <img src={firstitem.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginBottom: 10 }} />
                                    <div style={{  display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                        <div style={{ fontSize: 16, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                                        <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 10 }}>{firstitem.title}</div>
                                        <div style={{ fontSize: 16, textAlign: 'center', padding: 10 }}>{firstitem.info}</div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>,
                    <div key="party_key" style={{ width: partywt, color: fc, display: 'flex', flexDirection: 'column', alignSelf: 'center', padding: '40px 0px' }}>
                        {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
                        <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                            <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                                {displaytxtmap['party']}
                            </div>
                        </div>
                        {party.map((item, index) => {
                            const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                            const imgdim = 150
                            // party's item : id, email, info, name, number, photo, title 
                            // partyproperties : format, imageshape
                            return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', }}>
                                <div onClick={() => partyportalclick(index)} id={item.id} style={{ width: '100%', height: 250, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                    <img src={item.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginBottom: 10 }} />
                                    <div style={{ display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                        <div style={{ fontSize: 16, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{item.name}</div>
                                        <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{item.title}</div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                ][partyproperties.format]
                : <div key='party_dom' />
        }
        else { //  WEB, TABLET
            return party && party.length > 0 && displayonoffmap && displayonoffmap['party']
                ? [
                    <div key="party_key" style={{ width: partywt, color: fc, display: 'flex', flexDirection: 'column', alignSelf: 'center', padding: '40px 0px' }}>
                        {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
                        <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                            <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                                {displaytxtmap['party']}
                            </div>
                        </div>
                        {party.map((item, index) => {

                            if ((index + 1) % 2 === 0) return
                            const firstitem = party[index]
                            const seconditem = ((index + 1) < party.length) ? party[index + 1] : null
                            const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                            const imgdim = 150
                            if (seconditem) {
                                return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', marginBottom: 30 }}>
                                    <div id={firstitem.id} style={{ width: '50%', minHeight: 300, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                        <img src={firstitem.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, }} />
                                        <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                            <div style={{ fontSize: fs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', }}>{firstitem.name}</div>
                                            <div style={{ fontSize: fs - 2, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{firstitem.title}</div>
                                            <div style={{ fontSize: fs, textAlign: 'center', padding: 10 }}>{firstitem.info}</div>
                                        </div>
                                    </div>
                                    <div id={seconditem.id} style={{ width: '50%', minHeight: 300, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                        <img src={seconditem.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim }} />
                                        <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                            <div style={{ fontSize: fs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{seconditem.name}</div>
                                            <div style={{ fontSize: fs - 2, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{seconditem.title}</div>
                                            <div style={{ fontSize: fs, textAlign: 'center', padding: 10 }}>{seconditem.info}</div>
                                        </div>
                                    </div>
                                </div>
                            }
                            else {
                                return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', marginBottom: 30, placeContent: 'center' }}>
                                    <div id={firstitem.id} style={{ width: '50%', minHeight: 300, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                        <img src={firstitem.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim }} />
                                        <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                            <div style={{ fontSize: 16, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                                            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{firstitem.title}</div>
                                            <div style={{ fontSize: 16, textAlign: 'center', padding: 10 }}>{firstitem.info}</div>
                                        </div>
                                    </div>
                                </div>
                            }
                        })}
                    </div>,
                    <div key="party_key" style={{ width: partywt, color: fc, display: 'flex', flexDirection: 'column', alignSelf: 'center', padding: '40px 0px' }}>
                        {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
                        <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                            <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                                {displaytxtmap['party']}
                            </div>
                        </div>
                        {party.map((item, index) => {
                            if ((index + 1) % 2 === 0) return
                            const firstitem = party[index]
                            const seconditem = ((index + 1) < party.length) ? party[index + 1] : null
                            const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                            const imgdim = 150
                            if (seconditem) {
                                return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', marginBottom: 30 }}>
                                    <div onClick={() => partyportalclick(index)} id={firstitem.id} style={{ width: '50%', minHeight: 250, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                        <img src={firstitem.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim }} />
                                        <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                            <div style={{ fontSize: 16, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                                            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{firstitem.title}</div>
                                        </div>
                                    </div>
                                    <div onClick={() => partyportalclick(index + 1)} id={seconditem.id} style={{ width: '50%', minHeight: 250, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                        <img src={seconditem.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim }} />
                                        <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                            <div style={{ fontSize: 16, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{seconditem.name}</div>
                                            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{seconditem.title}</div>
                                        </div>
                                    </div>
                                </div>
                            }
                            else {
                                return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', marginBottom: 30, placeContent: 'center' }}>
                                    <div onClick={() => partyportalclick(index)} id={firstitem.id} style={{ width: '50%', minHeight: 300, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                        <img src={firstitem.photo} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim }} />
                                        <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                            <div style={{ fontSize: 16, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 20 }}>{firstitem.name}</div>
                                            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 10 }}>{firstitem.title}</div>
                                        </div>
                                    </div>
                                </div>
                            }
                        })}
                    </div>
                ][partyproperties.format]
                : <div key='party_dom' />
        }

    }

    // brave
    const singlepartymember_dom = <div style={{ color: fc, backgroundColor: templatecolor, position: 'fixed', width: '100%', height: '100%', zIndex: 999999, top: 0, overflowX: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: 'rgba(121, 121, 121, 0.5) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px', touchAction: 'manipulation' }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => {
                setShowparty(false);
                setSinglepartymemberdata({})
                document.getElementById('ilookupt1').style.position = ''
                window.scrollTo(0, lastcapturePosition);
            }}
        />
        <div key={singlepartymemberdata.id} style={{ display: 'flex', fontFamily: priff, flexDirection: 'column', width: 300, placeItems: 'center', placeSelf: 'center', marginTop: 50, padding: 10, overflowY: 'auto' }}>
            <img src={singlepartymemberdata.photo} style={{ borderRadius: partyproperties && partyproperties['imageshape'] ? '100%' : 5, minWidth: 150, minHeight: 150, maxWidth: 150, maxHeight: 150, marginBottom: 25 }} />
            <div style={{ fontSize: 16, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{singlepartymemberdata.name}</div>
            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5, }}>{singlepartymemberdata.title}</div>
            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5, }}>{singlepartymemberdata.number}</div>
            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5, }}>{singlepartymemberdata.email}</div>
            <div style={{ fontSize: 14, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 25, whiteSpace: 'pre-wrap', textAlign: 'center' }}>{singlepartymemberdata.info}</div>
        </div>
    </div>

    const qns_dom = (wt, fs) => {
        const title_fs = device === 'MOBILE' ? 24 : 28
        // return qnas && qnas.length > 0
        return displayonoffmap && displayonoffmap['qna']
            ? <div key='qns_valid' style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', alignSelf: 'center', padding: '40px 0px' }}> {/* boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none', borderRadius: device === 'MOBILE' ? 20 : 0,*/}
                {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
                <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                    <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                        {displaytxtmap['qna']}
                    </div>
                </div>
                {genQnas(fs, qnas, device)}
            </div>
            : <div key='qns_nonvalid' />
    }

    const schedule_dom = (wt, ht, fs) => {
        const title_fs = device === 'MOBILE' ? 24 : 28

        var urlhandler = props.match.params.invitationlookup.toLowerCase()
        var passcode = props.match.params.passcode
        var guestuid = props.match.params.guestuid

        const is_guest_logged = (urlhandler && urlhandler.length > 0)
            && (passcode && passcode.length > 0)
            && (guestuid ? (guestuid && guestuid.length > 0) : false)
        // const is_guest_logged = ((urlhandler ? true : false) && (passcode ? true : false) && (guestuid ? true : false))

        // return displayonoffmap && displayonoffmap['schedule'] && schedules && schedules.length > 0
        //     ? <div key='schedule' style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', padding: '40px 0px' }}> {/* boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none', borderRadius: device === 'MOBILE' ? 20 : 0,*/}
        //         {stylesep && stylesep.length > 0 && schedules && schedules.length > 0 ? <div style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
        //         <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
        //             <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>{displaytxtmap['schedule']}</div>
        //         </div>
        //         {schedules.map((item, index) => { // brute
        //             return (
        //                 <Timelineobj
        //                     from="Invitationlookup"
        //                     key={'timeline' + index}
        //                     index={index}
        //                     bb={index !== schedules.length - 1 ? `0.5px solid ${fc}` : 'none'} // borderBottom
        //                     date_s={item[0]}
        //                     date_e={item[1]}
        //                     time_s={item[2]}
        //                     time_e={item[3]}
        //                     name={item[4]}
        //                     content={item[5]}
        //                     mapobj={item[7]}
        //                     itineraryobj={item[8]}
        //                     pri_fs={fs}
        //                     sec_fs={fs}
        //                     // wt={wt * 0.95}
        //                     wt={wt}
        //                     dttimebox_wt={'max-content'}
        //                     content_ht={ht}
        //                     finalindex={index === schedules.length - 1}
        //                     fc={fc}
        //                     bgc={templatecolor}
        //                     mapmode={mapmode}
        //                     expandbtn={true}
        //                 />
        //             )
        //             // const whocanview_list = item[6]
        //             // if (whocanview_list.includes(guestid)) {
        //             //     return (
        //             //         <Timelineobj
        //             //             from="Invitationlookup"
        //             //             key={'timeline' + index}
        //             //             index={index}
        //             //             bb={index !== schedules.length - 1 ? `0.5px solid ${fc}` : 'none'} // borderBottom
        //             //             date_s={item[0]}
        //             //             date_e={item[1]}
        //             //             time_s={item[2]}
        //             //             time_e={item[3]}
        //             //             name={item[4]}
        //             //             content={item[5]}
        //             //             mapobj={item[7]}
        //             //             itineraryobj={item[8]}
        //             //             pri_fs={fs}
        //             //             sec_fs={fs}
        //             //             // wt={wt * 0.95}
        //             //             wt={wt}
        //             //             dttimebox_wt={'max-content'}
        //             //             content_ht={ht}
        //             //             finalindex={index === schedules.length - 1}
        //             //             fc={fc}
        //             //             bgc={templatecolor}
        //             //             mapmode={mapmode}
        //             //             expandbtn={true}
        //             //         />
        //             //     )
        //             // }
        //             // else {
        //             //     return null
        //             // }


        //         })}
        //     </div>
        //     : <div key='schedule' />


        // return displayonoffmap && displayonoffmap['schedule']
        //     ? is_guest_logged
        //         ? schedules && schedules.length > 0
        //             ? <div key='schedule' style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', padding: '40px 0px' }}> {/* boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none', borderRadius: device === 'MOBILE' ? 20 : 0,*/}
        //                 {stylesep && stylesep.length > 0 && schedules && schedules.length > 0 ? <div style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
        //                 <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
        //                     <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>{displaytxtmap['schedule']}</div>
        //                 </div>
        //                 {schedules.map((item, index) => { // brute
        //                     return (
        //                         <Timelineobj
        //                             from="Invitationlookup"
        //                             key={'timeline' + index}
        //                             index={index}
        //                             bb={index !== schedules.length - 1 ? `0.5px solid ${fc}` : 'none'} // borderBottom
        //                             date_s={item[0]}
        //                             date_e={item[1]}
        //                             time_s={item[2]}
        //                             time_e={item[3]}
        //                             name={item[4]}
        //                             content={item[5]}
        //                             mapobj={item[7]}
        //                             itineraryobj={item[8]}
        //                             pri_fs={fs}
        //                             sec_fs={fs}
        //                             // wt={wt * 0.95}
        //                             wt={wt}
        //                             dttimebox_wt={'max-content'}
        //                             content_ht={ht}
        //                             finalindex={index === schedules.length - 1}
        //                             fc={fc}
        //                             bgc={templatecolor}
        //                             mapmode={mapmode}
        //                             expandbtn={true}
        //                         />
        //                     )
        //                 })}
        //             </div>
        //             : <div key='schedule' />
        //         : <div key='schedule' style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', padding: '40px 0px' }}>
        //             {stylesep && stylesep.length > 0 ? <div style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
        //             <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
        //                 <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>{displaytxtmap['schedule']}</div>
        //             </div>
        //             <div style={{ fontSize: fs }}>Please use the guest invitation to view the schedule.</div>
        //         </div>
        //     : <div key='schedule' />

        const none_dom = <div key='noneschedule' />
        const needgid_dom = <div key='schedule' style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', padding: '40px 0px' }}>
            {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
            <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>{displaytxtmap['schedule']}</div>
            </div>
            <div style={{ fontSize: fs, padding: '0px 20px', width: '100%', placeContent: 'center', display: 'flex', flexDirection: 'column', placeItems: 'center' }}>
                {iconwrapper(LOCK_ICON, { width: 50, height: 50, display: 'flex', placeContent: 'center', margin: '0px 20px 30px' })}
                <button
                    style={{ border: `1px solid ${fc}`, padding: '5px 10px', borderRadius: 5, backgroundColor: templatecolor, marginBottom: 30 }}
                    onClick={() => {

                    }}
                >
                    Login
                </button>
                <div>Please use the guest invitation to view the schedule.</div>
            </div>
        </div>

        const allschedules_dom = <div key='allschedules' style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', padding: schedules && schedules.length > 0 ? '40px 0px' : '' }}> {/* boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none', borderRadius: device === 'MOBILE' ? 20 : 0,*/}
            {stylesep && stylesep.length > 0 && schedules && schedules.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
            {schedules && schedules.length > 0
                ? <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                    <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>{displaytxtmap['schedule']}</div>
                </div>
                : null}
            {schedules.map((item, index) => { // brute
                return (
                    <Timelineobj
                        from="Invitationlookup"
                        key={'timeline' + index}
                        index={index}
                        bb={index !== schedules.length - 1 ? `1px solid ${fc}4d` : 'none'} // borderBottom
                        date_s={item[0]}
                        date_e={item[1]}
                        time_s={item[2]}
                        time_e={item[3]}
                        name={item[4]}
                        content={item[5]}
                        whocanview={item[6]}
                        mapobj={item[8]}
                        itineraryobj={item[9]}
                        pri_fs={fs}
                        sec_fs={fs}
                        // wt={wt * 0.95}
                        wt={wt}
                        dttimebox_wt={'max-content'}
                        content_ht={ht}
                        finalindex={index === schedules.length - 1}
                        fc={fc}
                        bgc={templatecolor}
                        mapmode={mapmode}
                        expandbtn={true}
                    />
                )
            })}
        </div>

        if (displayonoffmap && displayonoffmap['schedule']) {
            // if (schedules && schedules.length > 0) return allschedules_dom
            // else return is_guest_logged ? none_dom : needgid_dom
            return allschedules_dom
            // if (schedules && schedules.length > 0) return allschedules_dom
            // else return is_guest_logged ? none_dom : needgid_dom
        }
        else {
            return none_dom
        }

    }

    const proposal_dom = (wt, fs) => {
        const title_fs = device === 'MOBILE' ? 24 : 28
        // return wproposal && wproposal.length === 2 && wproposal[1].length > 0 ?
        return wproposal && displayonoffmap && displayonoffmap['proposal'] ?
            <div key="proposal" style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', alignSelf: 'center', padding: '40px 0px' }}> {/* boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none', borderRadius: device === 'MOBILE' ? 20 : 0,*/}
                {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
                <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                    <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                        {displaytxtmap['proposal']}
                    </div>
                </div>
                <div style={{ padding: '0px 20px 0px 20px', fontSize: fs, lineHeight: FS_LH_MAP[fs], ...css_map['proposal'] }}>{wproposal}</div>
            </div>
            : <div key='proposal' />
    }

    const howwemet_dom = (wt, fs) => {
        const title_fs = device === 'MOBILE' ? 24 : 28
        // return whowwemet && whowwemet.length === 2 && whowwemet[1].length > 0 ?
        return whowwemet && displayonoffmap && displayonoffmap['howwemet']
            ? <div key={'howwemet'} style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', alignSelf: 'center', padding: '40px 0px' }}> {/* boxShadow: device === 'MOBILE' ? 'rgba(25, 25, 25, 0.25) 0px 2px 3px' : 'none', borderRadius: device === 'MOBILE' ? 20 : 0,*/}
                {stylesep && stylesep.length > 0 ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} /> : null}
                <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                    <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                        {displaytxtmap['howwemet']}
                    </div>
                </div>
                <div style={{ padding: '0px 20px 0px 20px', fontSize: fs, lineHeight: FS_LH_MAP[fs], ...css_map['howwemet'] }}>{whowwemet}</div>
            </div>
            : <div key='howwemet_none' />
    }

    const map_dom = (wt, fs) => {
        const title_fs = device === 'MOBILE' ? 24 : 28

        const {
            maptype, locdescript,
            leafletlocurl, leafletmapmode, leafletlat, leafletlong
        } = location_map

        const cssdescription = css_map['locdescript']

        return displayonoffmap && displayonoffmap['map']
            ? <div key='map_root' style={{ width: wt, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignSelf: 'center', margin: '40px 0px' }}>
                {stylesep && stylesep.length > 0 && locurl && locurl.length > 0
                    ? <div className='ilookup_banner' style={{ width: '100%', height: 40, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} />
                    : null}
                <div style={{ fontSize: fs, lineHeight: FS_LH_MAP[fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', padding: '20px 20px 30px 20px', }}>
                    <div style={{ padding: '0px 5px', borderRadius: 5, fontSize: title_fs, fontFamily: secff, }}>
                        {displaytxtmap['map']}
                    </div>
                </div>
                {{
                    'GOOGLE': <iframe style={{ width: wt, height: 300, border: 'none' }}{...mapiframe}></iframe>,
                    'LEAFLET': <div style={{ width: wt, position: 'relative', height: '100%' }}>
                        <a style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', position: 'absolute', zIndex: 999, right: 0, backgroundColor: 'transparent', borderRadius: 5, cursor: 'pointer', margin: 10 }} href={leafletlocurl} target='_blank'                         >
                            {iconwrapper(EXPAND_ICON, { width: 27, height: 27, display: 'flex', borderRadius: 4, padding: 5, placeContent: 'center', alignItems: 'center', backgroundColor: 'white', boxShadow: 'rgba(0, 0, 0, 0.65) 0px 1px 5px', color: 'var(--maindark)' })}
                        </a>
                        <Jfmap markersData={[{ latLng: { lat: leafletlat, lng: leafletlong } }]} mapmode={leafletmapmode} />
                    </div>
                }[maptype]}

                <div style={{ display: 'flex', flexWrap: 'wrap', padding: '20px 20px 0px 20px', fontSize: 16, whiteSpace: 'pre-wrap', ...cssdescription }}>
                    {locdescript}
                </div>
            </div>
            : <div key='map11' />

    }

    const socialmedia_dom = () => { // INACTIVE
        return null
        try {
            const fb_link = socialmedialinks[0]
            const insta_link = socialmedialinks[1]
            const whatsapp_links = socialmedialinks[2]
            const telegram_links = socialmedialinks[3]
            const local_css = { padding: 10, margin: 10, outline: 'none', borderRadius: 100, color: fc } //border: 'thin solid #d0d0d0', boxShadow: 'rgba(0, 0, 0, 0.2) -4px 4px 1rem -0.1875rem', backgroundColor: 'white'

            if (fb_link.length === 0 && insta_link.length === 0 && whatsapp_links.length === 0 && telegram_links.length === 0) {
                return promote.length > 0
                    ? <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', padding: 20 }}>
                        <span target="blank" href={telegram_links} style={{ ...local_css, border: 'thin solid #c0c0c05e', borderRadius: 0, cursor: 'pointer' }} onClick={() => setShowpromote(true)}>{HUMAN_ICON}</span>
                    </div>
                    : null
            }

            return (
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', margin: '40px 0px' }}>
                    {fb_link.length > 0 ? <a target="blank" href={fb_link} style={local_css}>
                        {FACEBOOK_ICON}
                    </a> : null}
                    {insta_link.length > 0 ? <a target="blank" href={insta_link} style={local_css}>
                        {INSTAGRAM_ICON}
                    </a> : null}
                    {whatsapp_links.length > 0 ? <a target="blank" href={whatsapp_links} style={local_css}>
                        {iconwrapper(THINWHATSAPP_ICON, GENERALICON_CSS)}
                    </a> : null}
                    {telegram_links.length > 0 ? <a target="blank" href={telegram_links} style={local_css}>
                        {iconwrapper(THINTELEGRAM_ICON, GENERALICON_CSS)}
                    </a> : null}
                    {promote && promote.length > 0 ? <span target="blank" href={telegram_links} style={{ ...local_css, borderLeft: 'thin solid #c0c0c05e', borderRadius: 0, cursor: 'pointer' }} onClick={() => setShowpromote(true)}>{HUMAN_ICON}</span> : null}
                </div>
            )
        }
        catch (e) { return null }
    }

    const registry_dom = <div style={{ color: fc, backgroundColor: templatecolor, position: 'fixed', width: '100%', height: '100%', zIndex: 999999, top: 0, overflowX: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: 'rgba(121, 121, 121, 0.5) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px', touchAction: 'manipulation' }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => {
                setShowregistry(false);
                document.getElementById('ilookupt1').style.position = ''
                window.scrollTo(0, lastcapturePosition);
            }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', placeContent: 'flex-start', marginTop: 50, padding: 10 }}>
            <div className='RSVP_titleroot' style={{ fontFamily: secff, color: fc }}>Registry</div>
            {registry && registry.length > 0
                ? registry.map((r, i) => {
                    if (i % 2 === 0) {
                        return <a
                            key={i + 'registry'}
                            href={registry[i]}
                            className='ilookup_morebtn'
                            style={{
                                flexDirection: 'column',
                                placeContent: 'center',
                                borderBottom: `0.5px solid ${fc}3d`,
                                color: fc,
                                alignItems: 'flex-start'
                            }}
                            target={"_blank"}
                        >
                            <div>{registry[i] ? registry[i] : ''} </div>
                            <div style={{ fontSize: 14, color: fc, opacity: 0.8 }}>{' ( ' + registry[i - 1] ? registry[i - 1] : '' + ' ) '} </div>
                        </a>
                    }
                    else return null
                })
                : null}
        </div>
    </div>


    const promote_dom = <div style={{ color: fc, backgroundColor: templatecolor, position: 'fixed', width: '100%', height: '100%', zIndex: 999999, top: 0, overflowX: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: 'rgba(121, 121, 121, 0.5) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px', touchAction: 'manipulation' }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => {
                setShowpromote(false);
                document.getElementById('ilookupt1').style.position = ''
                window.scrollTo(0, lastcapturePosition);
            }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', placeContent: 'flex-start', marginTop: 50, padding: 10 }}>
            <div className='RSVP_titleroot' style={{ fontFamily: secff, color: fc }}>Promote</div>
            {promote.map((v, i) => {
                if (i % 3 === 0) {
                    return <a
                        key={promote[i + 1] + i}
                        href={promote[i + 1]}
                        className='ilookup_morebtn'
                        style={{
                            flexDirection: 'column',
                            placeContent: 'center',
                            borderBottom: `0.5px solid ${fc}3d`,
                            color: fc,
                            alignItems: 'flex-start'
                        }}
                        target={"_blank"}
                    >
                        <div>{promote[i]} </div>
                        <div style={{ fontSize: 14, color: fc, opacity: 0.8 }}>{promote[i + 2].length > 0 ? ' ( ' + promote[i + 2] + ' ) ' : null} </div>
                    </a>
                }
                else return null
            })}
        </div>
    </div>

    const share_dom = <div style={{ color: fc, backgroundColor: templatecolor, position: 'fixed', width: '100%', height: '100%', zIndex: 999999, top: 0, overflowX: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: 'rgba(121, 121, 121, 0.5) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px', touchAction: 'manipulation' }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => {
                setShowshare(false);
                document.getElementById('ilookupt1').style.position = ''
                window.scrollTo(0, lastcapturePosition);
            }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', placeContent: 'flex-start', marginTop: 50, padding: 10 }}>
            <div className='RSVP_titleroot' style={{ fontFamily: secff, color: fc }}>Share</div>
            {socialmedialinks.map((v, i) => {
                const media_name = ['Facebook', 'Instagram', 'Whatsapp', 'Telegram'][i]
                const localicon = PARAMS_MEDIA_MAP[media_name]['icon']
                return <a
                    className='ilookup_morebtn'
                    key={socialmedialinks[i] + i}
                    href={socialmedialinks[i]}
                    style={{
                        borderBottom: `0.5px solid ${fc}3d`,
                        color: fc,
                    }}
                >
                    <div style={{ textDecoration: 'none' }}>{localicon}</div>
                    <div style={{ paddingLeft: 10, textDecoration: 'none' }}>{media_name}</div>
                </a>
            })}
        </div>
    </div>

    const contact_dom = <div style={{ color: fc, backgroundColor: templatecolor, position: 'fixed', width: '100%', height: '100%', zIndex: 999999, top: 0, overflowX: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: 'rgba(121, 121, 121, 0.5) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px', touchAction: 'manipulation' }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => {
                setShowcontact(false);
                document.getElementById('ilookupt1').style.position = ''
                window.scrollTo(0, lastcapturePosition);
            }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', placeContent: 'flex-start', marginTop: 50, padding: 10 }}>
            <div className='RSVP_titleroot' style={{ fontFamily: secff, color: fc }}>Contact</div>
            {contacts.map((c, i) => {
                const { contacttype, who, val } = c
                let url = '';
                switch (contacttype) {
                    case 'Number':
                        url = `tel:${val}`; // Use tel: protocol for phone numbers
                        break;
                    case 'Telegram':
                        url = `https://t.me/${val}`;
                        break;
                    case 'Whatsapp':
                        url = `https://wa.me/${val}`;
                        break;
                    case 'Instagram':
                        url = `https://www.instagram.com/${val}`;
                        break;
                    case 'WeChat':
                        url = `weixin://dl/chat?${val}`;
                        break;
                    default:
                        url = '#'; // Fallback URL
                }

                return <div key={'contact' + i} className='ilookup_singlecontact'>
                    <div className='ilookup_whoval' >
                        <div className='ilookup_contactwho'>{who}</div>
                        <div className='ilookup_contactval'>{val}</div>
                    </div>
                    <div className='ilookup_contacticon' onClick={() => window.open(url, '_blank')}>
                        {PARAMS_MEDIA_MAP[contacttype]['icon']}
                    </div>
                </div>
            })}
        </div>
    </div>

    // console.log({ 'WEB': '', 'TABLET': '', 'MOBILE': (menumore.length > 5 ? '200vh' : '') }[device])
    const more_dom = <div style={{ color: fc, backgroundColor: templatecolor, position: 'fixed', width: '100%', height: '100%', zIndex: 999999, top: 0, overflowX: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: 'rgba(121, 121, 121, 0.5) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px', touchAction: 'manipulation' }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => {
                setShowmore(false);
                document.getElementById('ilookupt1').style.position = '';
                window.scrollTo(0, lastcapturePosition);
            }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', placeContent: 'flex-start', marginTop: 50, padding: 10, overflowY: 'auto' }}>
            <div className='RSVP_titleroot' style={{ fontFamily: secff, color: fc }}>More</div>
            {menumore.map((m, i) => {
                var urlhandler = props.match.params.invitationlookup.toLowerCase()
                var passcode = props.match.params.passcode
                var guestuid = props.match.params.guestuid
                const isrsvp = m === 'RSVP' && rsvpactive && rsvptype !== 'google' && passcode.length > 0 && urlhandler.length > 0 && guestuid && guestuid.length > 0 && rsvptype === 'default'
                if (isrsvp || m !== 'RSVP') {
                    return <button
                        key={'menumore' + i}
                        className='ilookup_morebtn'
                        style={{ borderBottom: `0.5px solid ${fc}3d` }}
                        onClick={(e) => {
                            const value = m
                            if (value !== 'Guestbook' && value !== 'Seatings') {
                                document.getElementById('ilookupt1').style.position = 'fixed'
                                setShowmore(false)
                            }
                            opensomething(value, 'More')
                        }}
                    >
                        <div className='ilookup_moreroot'>
                            <div className='ilookup_moreicon' >{ICON_MAP[m]}</div>
                            <div className='ilookup_moreval'>{m}</div>
                        </div>
                    </button>
                }
                else {
                    return null
                }

            })}
        </div>
    </div>


    const itinerary_onClick = (e) => {
        const { value } = e.target
        const win = window.open(value, "_blank");
        win.focus();
    }

    const itinerary_dom = <div style={{ color: fc, backgroundColor: templatecolor, position: 'fixed', width: '100%', height: '100%', zIndex: 999999, top: 0, overflowX: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: 'rgba(121, 121, 121, 0.5) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px', touchAction: 'manipulation' }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => {
                setShowitinerary(false);
                document.getElementById('ilookupt1').style.position = ''
                window.scrollTo(0, lastcapturePosition);
            }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', placeContent: 'flex-start', marginTop: 50, padding: 10, overflowY: 'auto' }}>
            <div className='RSVP_titleroot' style={{ fontFamily: secff, color: fc }}>Itinerary</div>
            {menuitems && menuitems['Itinerary'] && menuitems['Itinerary']['linkorurl'] && menuitems['Itinerary'][menuitems['Itinerary']['linkorurl']].length > 0
                ? <div className='ilookup_morebtn' >
                    {{
                        'link': <button className='ilookup_itinerarybtn' style={{ color: fc, border: `1px solid ${fc}`, placeContent: 'center' }} value={menuitems['Itinerary']['link']} onClick={itinerary_onClick}>{menuitems['Itinerary']['title']}</button>,
                        'url': <button className='ilookup_itinerarybtn' style={{ color: fc, border: `1px solid ${fc}`, placeContent: 'center' }} value={menuitems['Itinerary']['url']} onClick={itinerary_onClick}>{menuitems['Itinerary']['title']}</button>
                    }[menuitems['Itinerary']['linkorurl']]}
                </div>
                : null}
            {schedules && schedules.length > 0
                ? schedules.map((schedule, i) => {
                    const scheduletitle = schedule[4]
                    const itinerary = schedule[9]
                    const bt = i === 0 && menuitems['Itinerary'][menuitems['Itinerary']['linkorurl']].length > 0
                        ? `0.5px solid ${fc}3d`
                        : 'none'
                    const { itinerarystate, title, linkorurl, link, url } = itinerary

                    if (!itinerarystate) return
                    return <div
                        className='ilookup_morebtn'
                        key={'schedule' + i}
                        style={{ display: 'flex', flexDirection: 'column', borderBottom: 'none', borderTop: bt, placeContent: 'center' }} // paddingTop: i === 0 ? 10 : 0,
                    >
                        <div className='ilookup_itinerarytitle'>{scheduletitle}</div>
                        {{
                            'link': <button className='ilookup_itinerarybtn' style={{ color: fc, border: `1px solid ${fc}` }} value={link} onClick={itinerary_onClick}>{title}</button>,
                            'url': <button className='ilookup_itinerarybtn' style={{ color: fc, border: `1px solid ${fc}` }} value={url} onClick={itinerary_onClick}>{title}</button>,
                        }[linkorurl]}
                    </div>
                })
                : null}
        </div>
    </div>

    const noti_dom = <div className={notiexpand ? 'ilookupnotiexpand' : 'ilookupnoti'} style={{ height: notiexpand ? 'max-content !important' : '', backgroundColor: templatecolor, color: fc, borderTop: `0.5px solid ${fc}` }}>
        <Circularclosebtn
            fc={fc}
            bgc={templatecolor}
            clickfunc={() => { setNotificationbool(false) }}
            rootstyle={{ position: 'absolute', left: 'auto', right: 0 }} // move to right
        />

        {/* <button className={'Ilookup_noticlose'} style={{ backgroundColor: templatecolor, fill: fc }} onClick={() => setNotificationbool(false)}>{CLOSE_ICON}</button> */}
        <div className='ilookupnoticol'>
            <div className='ilookupnoticontent' style={{ fontFamily: notiff }}>
                <div className='ilookupnotititletxt' >
                    <div className='ilookupnotititle'>{notificationtitle} </div>
                    {notificationtxt.length > 300
                        ? <div className='ilookupnotitxt'>{!notiexpand ? notificationtxt.substring(0, 220) + '...' : notificationtxt}</div>
                        : <div className='ilookupnotitxt'>{notificationtxt}</div>
                    }
                </div>
                {!notiexpand && notificationtxt.length > 200
                    ? <button className='ilookupexpand' onClick={() => { setNotiexpand(true) }}>
                        <div className='ilookupexpandtxt' style={{ color: fc, border: `0.5px solid ${fc}` }}>Expand</div>
                    </button>
                    : null}
            </div>

        </div>
    </div>

    const rsvpbtn_dom = (wt) => {
        var urlhandler = props.match.params.invitationlookup.toLowerCase()
        var passcode = props.match.params.passcode
        var guestuid = props.match.params.guestuid
        const title_fs = device === 'MOBILE' ? 24 : 28
        const wt_based_ondevice = device === 'WEB' ? wt * 0.98 : wt
        const css = { width: wt_based_ondevice, color: fc, fontFamily: secff, fontSize: title_fs, backgroundColor: templatecolor, display: 'flex', placeContent: 'center', padding: 5, border: `1px solid ${fc}`, justifySelf: 'center', alignSelf: 'center', borderRadius: 5, outline: 'none', zIndex: 999999, margin: '40px 0px 40px 0px' }
        if (rsvpactive && rsvptype !== 'google' && passcode.length > 0 && urlhandler.length > 0 && guestuid && guestuid.length > 0 && rsvptype === 'default') {
            return <button
                key='rsvpbtn1'
                style={css}
                className={device === 'WEB' ? 'ilookup_rsvpbtn' : ''}
                onClick={() => {
                    debug ? console.log('passcode', passcode) : null
                    debug ? console.log('guestid', guestid) : null
                    try {
                        var urlhandler = props.match.params.invitationlookup
                        var passcode = props.match.params.passcode
                        var guestid = props.match.params.guestid
                        if (guestid) { // if gt guestid need check if is correct
                            let options = {
                                method: 'POST',
                                url: INVITATION_GUESTLIST_CHKGUESTID,
                                data: { urlhandler, passcode, guestid }
                            }
                            axios(options).then((result) => {
                                const { message } = result.data
                                if (message === 'SUCCESS') {
                                    setGuestid(guestuid)
                                    setShowrsvpdom(true)
                                }
                                else if (message === 'FAILURE') { alert('Wrong Passcode or Guest ID') }
                            })
                        }
                        else {
                            setShowrsvpdom(true) // no guestid, lets just proceed
                        }
                    }
                    catch (e) {
                        // props.history.push('/')
                    }
                }}>
                RSVP
            </button>
        }
        else if (rsvptype === 'google' && rsvpactive) {
            return <button
                key='rsvpbtn2'
                style={css}
                className='ilookup_rsvpbtn'
                onClick={() => {
                    if (rsvptype === 'google' && rsvpalt && rsvpalt.length === 2 && rsvpalt[0].length > 0) {
                        rsvp_ref.current.click()
                    }
                }}>
                <a href={rsvpalt[0]} target="blank" style={{ visibility: 'hidden', position: 'absolute', width: 0, height: 0 }} ref={rsvp_ref}> </a>
                RSVP
            </button>
        }
        else {
            return <div key='emptyrsvp' style={{ width: 0, height: 0, visibility: 'hidden' }} />
        }
    }

    const alticlinks_dom = () => { // for Bilingual btns  INACTIVE
        return null
        // try {
        //     var btns = []
        //     const local_css = { padding: 5, margin: 5, outline: 'none', borderRadius: 100, fontSize: f_fs, color: 'inherit' } //border: 'thin solid #d0d0d0', boxShadow: 'rgba(0, 0, 0, 0.2) -4px 4px 1rem -0.1875rem', backgroundColor: 'white'
        //     for (let i = 0; i < alticlinks.length; i = i + 2) {
        //         if (alticlinks[i + 1].length > 0) {
        //             btns.push(
        //                 <a key={alticlinks[i + 1] + i} href={alticlinks[i + 1]} style={local_css} target="_blank" >{alticlinks[i]}</a>
        //             )
        //         }
        //     }
        //     return btns.length > 0
        //         ? <div style={{ color: fc, display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', zIndex: 1 }}> {btns} </div>
        //         : null
        // }
        // catch (e) {
        //     return null
        // }
    }

    const opensomething = (ms, from = '') => { // brave
        if (from !== 'More') {
            setLastcapturePosition(scrollPosition)
        }

        if (ms === 'Guestbook' || ms === 'Seatings') { // this all has url link 
            const final_web_link = menuitems[ms][menuitems[ms]['linkorurl']]
            const win = window.open('https://' + final_web_link, "_blank");
            win.focus();
        }
        // else if (ms === 'Registry') { // brave
        //     const { url } = registry
        //     const win = window.open(url, "_blank");
        //     win.focus();
        // }
        else if (ms === 'Itinerary') {
            setShowitinerary(true)
            document.getElementById('ilookupt1').style.position = 'fixed'
        }
        else if (ms === 'RSVP') {
            if (rsvptype === 'google') {
                rsvp_ref.current.click()
            }
            else if (rsvptype === 'default') {
                setShowrsvpdom(true)
            }
        }
        else if (ms === 'Gallery') {
            setShowgallery(true)
            // document.getElementById('ilookup_root').style.position = 'fixed'
            document.getElementById('ilookupt1').style.position = 'fixed'
        }
        else if (ms === 'Contact') {
            setShowcontact(true)
            document.getElementById('ilookupt1').style.position = 'fixed'
        }
        else if (ms === 'More') {
            setShowmore(true)
            document.getElementById('ilookupt1').style.position = 'fixed'
        }
        else if (ms === 'Share') {
            setShowshare(true)
            document.getElementById('ilookupt1').style.position = 'fixed'
        }
        else if (ms === 'Promote') {
            setShowpromote(true)
            document.getElementById('ilookupt1').style.position = 'fixed'
        }
        else if (ms === 'Registry') {
            setShowregistry(true)
            document.getElementById('ilookupt1').style.position = 'fixed'
        }
        else if (ms === 'Party') {
            setShowparty(true)
            document.getElementById('ilookupt1').style.position = 'fixed'
        }


    }

    const bar_dom = () => {
        const btmbarwt = {
            'MOBILE': '100%',
            'TABLET': 650,
            'WEB': 750
        }

        const color = menuattr_map[templatetype]['color']
        const bgcolor = menuattr_map[templatetype]['backgroundColor']
        const bordercolor = menuattr_map[templatetype]['borderColor']


        // none, btmnavbar, stickytopnav, menu, btmnavbarwithouticon,
        return menutype === 'btmnavbar'
            ? <div
                className={`T1_btmnav T1_btmnav_${menuseq.length}${menuicongate ? '' : '_nonicon'}`}
                style={{
                    fontFamily: btmbarff,
                    backgroundColor: bgcolor,
                    color: color,
                    width: btmbarwt[device],
                    border: '1px solid ' + bordercolor,
                    display: 'flex',
                    flexDirection: 'row',
                    borderBottom: 'none',
                    position: 'fixed',
                    bottom: 0,
                    zIndex: 999999,
                    borderTopLeftRadius: 30,
                    borderTopRightRadius: 30,
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    alignItems: 'center'
                }}>
                {menuseq.map((ms, index) => {
                    if (menuicongate) {
                        return <div
                            key={index + 'ms'}
                            className={`ilookup_btmnavbaritem ilookup_${menuseq.length}_btmnavbaritem`}
                            onClick={() => opensomething(ms)}
                        >
                            {ICON_MAP[ms]}
                            <div className='ilookup_btmtxt'>{ms}</div>
                        </div>
                    }
                    else {
                        return <div
                            key={index + 'ms'}
                            className={`ilookup_btmnavbaritem ilookup_${menuseq.length}_itemwithouticon`}
                            onClick={() => opensomething(ms)}
                        >
                            {ms}
                        </div>
                    }

                })}
            </div>
            : menutype === 'stickytopnav'
                ? <div
                    className={`ilookup_topnav ilookup_topnav_${menuseq.length}`}
                    style={{
                        fontFamily: btmbarff,
                        backgroundColor: bgcolor,
                        color: color,
                        width: '100%',
                        borderBottom: '1px solid ' + bordercolor,
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'fixed',
                        top: 0,
                        zIndex: 999999,
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        alignItems: 'center',
                        overflowX: 'auto'
                    }}>
                    {menuseq.map((ms, index) => {
                        return <div
                            key={index + 'ms'}
                            className={`ilookup_topnavsingleitembasic ilookup_topnavsingleitem_${menuseq.length}`} // style={{ width: appwt, minWidth: appwt }}
                            onClick={() => opensomething(ms)}
                        >
                            {ms}
                        </div>
                    })}
                </div>
                : null
    }

    const loadimg0 = () => {
        try {
            // return <div style={{ display: templateimageloaded ? 'none' : 'flex' }}>{id_bgstylea_map[styletype] ? '' : id_bgstylea_map[styletype][0]}</div>
        }
        catch (e) { return null }
    }

    const loadimg1 = () => {
        try {
            // return <div style={{ display: templateimageloaded ? 'none' : 'flex' }}>{id_bgstyleb_map[styletype] ? '' : id_bgstyleb_map[styletype][0]}</div>
        }
        catch (e) { return null }
    }

    const TYPE_DOM_MAP = {
        1: <T1
            {...props}

            displayseq={displayseq}

            wt={wt}
            ht={ht}
            WEB_TABLET_WT={WEB_TABLET_WT}
            device={device}

            // DATA FROM BACKEND
            css_map={css_map}
            priff={priff}

            styletype={styletype}
            styleformation={styleformation}
            styleborder={styleborder}
            styleborderwt={styleborderwt}
            styleborderbr={styleborderbr}
            stylebordercolor={stylebordercolor}

            fc={fc}
            templatecolor={templatecolor}
            textures={textures}

            rsvpactive={rsvpactive}

            id_bgstyleb_map={id_bgstyleb_map} // only IMG 
            id_bgstylea_map={id_bgstylea_map}

            locurl={locurl} // location url

            showtitle={showtitle} // title must show before anything else

            menutype={menutype}

            // FACTORY OF DOMS
            T1titles_dom={T1titles_dom}
            pagescrolldown_dom={pagescrolldown_dom}
            mainimg_dom={mainimg_dom}
            alticlinks_dom={alticlinks_dom}
            qns_dom={qns_dom}
            rsvpbtn_dom={rsvpbtn_dom}
            maintext_dom={maintext_dom}
            party_dom={party_dom}

            subtext_dom={subtext_dom}
            location_dom={location_dom}
            datetime_dom={datetime_dom}
            schedule_dom={schedule_dom}
            map_dom={map_dom}
            socialmedia_dom={socialmedia_dom}
            proposal_dom={proposal_dom}
            howwemet_dom={howwemet_dom}
            bar_dom={bar_dom}

            // FONT SIZE FOR MOBILE
            maintext_fs_mobile={maintext_fs_mobile}
            subtext_fs_mobile={subtext_fs_mobile}
            title_fs_mobile={title_fs_mobile}
            qn_fs_mobile={qn_fs_mobile}
            datetime_fs_mobile={datetime_fs_mobile}
            schedule_fs_mobile={schedule_fs_mobile}
            map_fs_mobile={map_fs_mobile}
            party_fs_mobile={party_fs_mobile}

            // overflow hidden, if is true
            showpromote={showpromote}

            // image related css
            imgcss_map={imgcss_map}
        />,
        2: <T2
            {...props}

            displayseq={displayseq}

            name1={name1}
            name2={name2}

            wt={wt}
            ht={ht}
            WEB_TABLET_WT={WEB_TABLET_WT}

            // DATA FROM BACKEND
            css_map={css_map}
            priff={priff}

            prebuildtemplatedesign_map={prebuildtemplatedesign_map}
            styletype={(prebuildtemplatedesign_map && templatetype === 1 && prebuildtemplatedesign_map[templatetype])
                ? prebuildtemplatedesign_map[templatetype]['styletype']
                : ''}
            styleformation={styleformation}
            styleborder={styleborder}
            styleborderwt={styleborderwt}
            styleborderbr={styleborderbr}
            stylebordercolor={stylebordercolor}

            fc={fc}
            templatecolor={templatecolor}
            textures={textures}

            rsvpactive={rsvpactive}

            locurl={locurl} // location url

            showtitle={showtitle} // title must show before anything else

            menutype={menutype}

            // FACTORY OF DOMS
            T2titles_dom={T2titles_dom}
            pagescrolldown_dom={pagescrolldown_dom}
            mainimg_dom={mainimg_dom}
            alticlinks_dom={alticlinks_dom}
            qns_dom={qns_dom}
            rsvpbtn_dom={rsvpbtn_dom}
            maintext_dom={maintext_dom}
            party_dom={party_dom}

            subtext_dom={subtext_dom}
            location_dom={location_dom}
            datetime_dom={datetime_dom}
            schedule_dom={schedule_dom}
            map_dom={map_dom}
            socialmedia_dom={socialmedia_dom}
            proposal_dom={proposal_dom}
            howwemet_dom={howwemet_dom}
            bar_dom={bar_dom}

            // FONT SIZE FOR MOBILE
            maintext_fs_mobile={maintext_fs_mobile}
            subtext_fs_mobile={subtext_fs_mobile}
            title_fs_mobile={title_fs_mobile}
            qn_fs_mobile={qn_fs_mobile}
            datetime_fs_mobile={datetime_fs_mobile}
            schedule_fs_mobile={schedule_fs_mobile}
            map_fs_mobile={map_fs_mobile}
            party_fs_mobile={party_fs_mobile}

            // overflow hidden, if is true
            showpromote={showpromote}

            // image related css
            imgcss_map={imgcss_map}
        />
    }

    if (showrsvpdom) {
        return <RSVP
            {...props}
            closeRsvp={() => {
                setShowrsvpdom(false)
            }}
            templatecolor={templatecolor}
            currguestid_guestinfo_map={currguestid_guestinfo_map}
            updateCurrguestid_guestinfo_map={(new_obj) => {
                setCurrguestid_guestinfo_map(new_obj)
            }}
            grpmemberid_guestinfo_map={grpmemberid_guestinfo_map}
            updateGrpmemberid_guestinfo_map={(selectedguestid, new_obj) => {
                setGrpmemberid_guestinfo_map((grpmemberid_guestinfo_map) => {
                    grpmemberid_guestinfo_map[selectedguestid] = new_obj
                    return grpmemberid_guestinfo_map
                })
            }}
            grpmemberid_guestqnsarr_map={grpmemberid_guestqnsarr_map}
            guestid_defaultqnstate_map={guestid_defaultqnstate_map}
            grpleader={grpleader}
            rsvp_obj={rsvp_obj}
            priff={priff}
            secff={secff}
            ff={ff}
            fc={fc}
            name1={name1}
            name2={name2}
            date={date_w}
            time={time}
            location={location}
            itype={itype}
            guestid={guestid}
        />
    }

    if ((device === 'MOBILE') && wt > ht) {
        return <Nohori />
    }
    if (gtpw) { // hvnt login
        return <Loginpasscode
            url={INVITATION_LOOKUP_GTPASS}
            urlhandler={props.match.params.invitationlookup}
            bgcolor={'#fffbf3'}
            onsuccess={(data, passcode, urlhandler) => {
                const { message, card } = data
                if (message === 'SUCCESS') {

                    props.history.push('/invitation/' + urlhandler + '/passcode=' + passcode) // this will let user proceed to page without rsvp function
                    upateStates(card)
                    debug ? console.log(' -- this will let user proceed to page without rsvp function --  ') : null
                    // props.match.params.guestid
                    //     ? props.history.push('/invitation/' + urlhandler + '/passcode=' + pc + '/guestid=' + props.match.params.guestid)
                    //     : props.history.push('/invitation/' + urlhandler + '/passcode=' + pc)
                }
                else if (message === 'GTPASSCODE') {
                    setGtpw(true)
                }
            }}
        />
    }
    else { // login alrdy

        if (templatetype === -1 || !mainimageloaded) {
            return <div>
                <Loading />
                <div style={{ opacity: 0 }}> {mainimg_dom(100, 1)}</div>
            </div>
        }
        else if (templatetype === 1) {

            return <div id="ilookup_root" style={{ backgroundColor: showgallery ? templatecolor : '' }}>
                {loadimg0()}
                {loadimg1()}
                {showgallery && !showopening
                    ? <Igallery
                        {...props}
                        images={images}
                        closeGallery={() => {
                            setShowgallery(false);
                            document.getElementById('ilookupt1').style.position = ''
                            window.scrollTo(0, lastcapturePosition);
                        }}
                        templatecolor={templatecolor}
                        fc={fc}
                        secff={secff}
                    />
                    : null}

                {showopening
                    ? <Opening
                        closeopening={() => { setShowopening(false) }}
                        openingnames={openingnames}
                        openingclosing={openingclosing}
                        openingtype={openingtype}
                        openingobjs={openingobjs}
                        openingstoryobjs={openingstoryobjs}
                        animationtype={animationtype}
                        animationobjs={animationobjs}
                        templatecolor={templatecolor}
                    />
                    : showrsvpdom
                        ? null
                        : TYPE_DOM_MAP[templatetype]}

                {showregistry && !showopening ? registry_dom : null}
                {showpromote && !showopening ? promote_dom : null}
                {showshare && !showopening ? share_dom : null}
                {showcontact && !showopening ? contact_dom : null}
                {showmore && !showopening ? more_dom : null}
                {showitinerary && !showopening ? itinerary_dom : null}
                {showparty && !showopening ? singlepartymember_dom : null}
                {notificationbool && !showopening ? noti_dom : null}
                {videoadgate ? btmdiv : null}

            </div >
        }

        else if (templatetype === 2) {
            return <div id="ilookup_root" style={{ backgroundColor: showgallery ? templatecolor : undefined }}>
                {showgallery && !showopening && (
                    <Igallery
                        {...props}
                        images={images}
                        closeGallery={() => {
                            setShowgallery(false);
                            document.getElementById('ilookupt1').style.position = '';
                            window.scrollTo(0, lastcapturePosition);
                        }}
                        templatecolor={templatecolor}
                        fc={fc}
                        secff={secff}
                    />
                )}

                {showopening ? (
                    <Opening
                        closeopening={() => setShowopening(false)}
                        openingnames={openingnames}
                        openingclosing={openingclosing}
                        openingtype={openingtype}
                        openingobjs={openingobjs}
                        openingstoryobjs={openingstoryobjs}
                        animationtype={animationtype}
                        animationobjs={animationobjs}
                        templatecolor={templatecolor}
                    />
                ) : showrsvpdom ? null : TYPE_DOM_MAP[templatetype]}

                {!showopening && (
                    <>
                        {showregistry && registry_dom}
                        {showpromote && promote_dom}
                        {showshare && share_dom}
                        {showcontact && contact_dom}
                        {showmore && more_dom}
                        {showitinerary && itinerary_dom}
                        {showparty && singlepartymember_dom}
                        {notificationbool && noti_dom}
                    </>
                )}

                {videoadgate && btmdiv}

            </div>
        }
    }
}

export default Invitationlookup